msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: eu\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2025-04-21 05:33\n"
"Last-Translator: \n"
"Language-Team: Basque\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: eu\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:136
msgid "Locked"
msgstr "Babestua"

#. placeholder {0}: shortenNumber(statusesCount)
#: src/components/account-block.jsx:142
msgid "Posts: {0}"
msgstr "Bidalketak: {0}"

#. placeholder {0}: niceDateTime(lastStatusAt, { hideTime: true, })
#: src/components/account-block.jsx:147
msgid "Last posted: {0}"
msgstr "Azken bidalketa: {0}"

#: src/components/account-block.jsx:162
#: src/components/account-info.jsx:690
msgid "Automated"
msgstr "Automatizatua"

#: src/components/account-block.jsx:169
#: src/components/account-info.jsx:695
#: src/components/status.jsx:588
msgid "Group"
msgstr "Taldea"

#: src/components/account-block.jsx:179
msgid "Mutual"
msgstr "Batak bestea"

#: src/components/account-block.jsx:183
#: src/components/account-info.jsx:1762
msgid "Requested"
msgstr "Eskatuta"

#: src/components/account-block.jsx:187
#: src/components/account-info.jsx:1753
msgid "Following"
msgstr "Jarraitzen"

#: src/components/account-block.jsx:191
#: src/components/account-info.jsx:1144
msgid "Follows you"
msgstr "Jarraitzen dizu"

#: src/components/account-block.jsx:199
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {jarraitzaile #} other {# jarraitzaile}}"

#: src/components/account-block.jsx:208
#: src/components/account-info.jsx:738
msgid "Verified"
msgstr "Egiaztatua"

#. placeholder {0}: niceDateTime(createdAt, { hideTime: true, })
#. placeholder {0}: niceDateTime(createdAt, { hideTime: true, })
#: src/components/account-block.jsx:223
#: src/components/account-info.jsx:840
msgid "Joined <0>{0}</0>"
msgstr "<0>{0}</0>(e)an batu zen"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "Betiko"

#: src/components/account-info.jsx:385
msgid "Unable to load account."
msgstr "Ezin da kontua kargatu."

#: src/components/account-info.jsx:400
msgid "Go to account page"
msgstr "Joan kontuaren orrira"

#: src/components/account-info.jsx:429
#: src/components/account-info.jsx:760
#: src/components/account-info.jsx:790
msgid "Followers"
msgstr "jarraitzaile"

#. js-lingui-explicit-id
#: src/components/account-info.jsx:433
#: src/components/account-info.jsx:800
#: src/components/account-info.jsx:819
msgid "following.stats"
msgstr "jarraitzen"

#: src/components/account-info.jsx:436
#: src/components/account-info.jsx:836
#: src/pages/account-statuses.jsx:479
#: src/pages/search.jsx:341
#: src/pages/search.jsx:488
msgid "Posts"
msgstr "bidalketa"

#: src/components/account-info.jsx:444
#: src/components/account-info.jsx:1200
#: src/components/compose.jsx:2772
#: src/components/media-alt-modal.jsx:46
#: src/components/media-modal.jsx:358
#: src/components/status.jsx:1826
#: src/components/status.jsx:1843
#: src/components/status.jsx:1968
#: src/components/status.jsx:2588
#: src/components/status.jsx:2591
#: src/pages/account-statuses.jsx:523
#: src/pages/accounts.jsx:110
#: src/pages/hashtag.jsx:200
#: src/pages/list.jsx:158
#: src/pages/public.jsx:115
#: src/pages/scheduled-posts.jsx:87
#: src/pages/status.jsx:1232
#: src/pages/trending.jsx:469
msgid "More"
msgstr "Gehiago"

#: src/components/account-info.jsx:456
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0>(e)k adierazi du kontu berria duela:"

#: src/components/account-info.jsx:601
#: src/components/account-info.jsx:1358
msgid "Handle copied"
msgstr "Helbidea kopiatu da"

#: src/components/account-info.jsx:604
#: src/components/account-info.jsx:1361
msgid "Unable to copy handle"
msgstr "Ezin da helbidea kopiatu"

#: src/components/account-info.jsx:610
#: src/components/account-info.jsx:1367
msgid "Copy handle"
msgstr "Kopiatu helbidea"

#: src/components/account-info.jsx:616
msgid "Go to original profile page"
msgstr "Joan jatorrizko profilaren orrira"

#: src/components/account-info.jsx:634
msgid "View profile image"
msgstr "Ikusi profileko irudia"

#: src/components/account-info.jsx:651
msgid "View profile header"
msgstr "Ikusi goiburuko irudia"

#: src/components/account-info.jsx:666
#: src/components/account-info.jsx:1668
#: src/components/account-info.jsx:2187
msgid "Edit profile"
msgstr "Editatu profila"

#: src/components/account-info.jsx:685
msgid "In Memoriam"
msgstr "In Memoriam"

#: src/components/account-info.jsx:767
#: src/components/account-info.jsx:810
msgid "This user has chosen to not make this information available."
msgstr "Erabiltzaileak informazio hau publiko ez egitea aukeratu du."

#. placeholder {0}: ( postingStats.originals / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {1}: ( postingStats.replies / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {2}: ( postingStats.boosts / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#: src/components/account-info.jsx:865
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} bidalketa original, {1} erantzun, {2} bultzada"

#. placeholder {0}: postingStats.total
#. placeholder {1}: postingStats.daysSinceLastPost
#. placeholder {2}: postingStats.daysSinceLastPost
#. placeholder {3}: postingStats.daysSinceLastPost
#. placeholder {4}: postingStats.total
#. placeholder {5}: postingStats.total
#. placeholder {6}: postingStats.daysSinceLastPost
#: src/components/account-info.jsx:881
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {Azken bidalketa azken egunean} other {Azken bidalketa azken {2} egunetan}}} other {{3, plural, one {Azken {4} bidalketak azken egunean} other {Azken {5} bidalketak azken {6} egunetan}}}}"

#. placeholder {0}: postingStats.total
#. placeholder {1}: postingStats.total
#: src/components/account-info.jsx:897
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {Azken bidalketa azken urte(et)an} other {Azken {1} bidalketak azken urte(et)an}}"

#: src/components/account-info.jsx:922
#: src/pages/catchup.jsx:71
msgid "Original"
msgstr "Originalak"

#: src/components/account-info.jsx:926
#: src/components/status.jsx:2372
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1447
#: src/pages/catchup.jsx:2062
#: src/pages/status.jsx:955
#: src/pages/status.jsx:1578
msgid "Replies"
msgstr "Erantzunak"

#: src/components/account-info.jsx:930
#: src/pages/catchup.jsx:73
#: src/pages/catchup.jsx:1449
#: src/pages/catchup.jsx:2074
#: src/pages/settings.jsx:1159
msgid "Boosts"
msgstr "Bultzadak"

#: src/components/account-info.jsx:936
msgid "Post stats unavailable."
msgstr "Bidalketaren estatistikak ez daude erabilgarri."

#: src/components/account-info.jsx:967
msgid "View post stats"
msgstr "Ikusi bidalketen estatistikak"

#. placeholder {0}: niceDateTime(lastStatusAt, { hideTime: true, })
#: src/components/account-info.jsx:1148
msgid "Last post: <0>{0}</0>"
msgstr "Azken bidalketa: <0>{0}</0>"

#: src/components/account-info.jsx:1162
msgid "Muted"
msgstr "Mutututa"

#: src/components/account-info.jsx:1167
msgid "Blocked"
msgstr "Blokeatuta"

#: src/components/account-info.jsx:1176
msgid "Private note"
msgstr "Ohar pribatua"

#: src/components/account-info.jsx:1233
msgid "Mention <0>@{username}</0>"
msgstr "Aipatu <0>@{username}</0>"

#: src/components/account-info.jsx:1245
msgid "Translate bio"
msgstr "Itzuli biografia"

#: src/components/account-info.jsx:1256
msgid "Edit private note"
msgstr "Editatu ohar pribatua"

#: src/components/account-info.jsx:1256
msgid "Add private note"
msgstr "Gehitu ohar pribatua"

#: src/components/account-info.jsx:1276
msgid "Notifications enabled for @{username}'s posts."
msgstr "Jakinarazpenak gaitu dira @{username}(r)en bidalketetarako."

#: src/components/account-info.jsx:1277
msgid " Notifications disabled for @{username}'s posts."
msgstr " Jakinarazpenak gaitu dira @{username}(r)en bidalketetarako."

#: src/components/account-info.jsx:1289
msgid "Disable notifications"
msgstr "Ezgaitu jakinarazpenak"

#: src/components/account-info.jsx:1290
msgid "Enable notifications"
msgstr "Gaitu jakinarazpenak"

#: src/components/account-info.jsx:1307
msgid "Boosts from @{username} enabled."
msgstr "@{username}(r)en bultzadak gaitu dira."

#: src/components/account-info.jsx:1308
msgid "Boosts from @{username} disabled."
msgstr "@{username}(r)en bultzadak ezgaitu dira."

#: src/components/account-info.jsx:1319
msgid "Disable boosts"
msgstr "Ezgaitu bultzadak"

#: src/components/account-info.jsx:1319
msgid "Enable boosts"
msgstr "Gaitu bultzadak"

#: src/components/account-info.jsx:1335
#: src/components/account-info.jsx:1345
#: src/components/account-info.jsx:1933
msgid "Add/Remove from Lists"
msgstr "Gehitu zerrendara / kendu zerrendatik"

#: src/components/account-info.jsx:1384
#: src/components/status.jsx:1253
msgid "Link copied"
msgstr "Esteka kopiatu da"

#: src/components/account-info.jsx:1387
#: src/components/status.jsx:1256
msgid "Unable to copy link"
msgstr "Ezin da esteka kopiatu"

#: src/components/account-info.jsx:1393
#: src/components/shortcuts-settings.jsx:1059
#: src/components/status.jsx:1262
#: src/components/status.jsx:3359
msgid "Copy"
msgstr "Kopiatu"

#: src/components/account-info.jsx:1408
#: src/components/shortcuts-settings.jsx:1077
#: src/components/status.jsx:1278
msgid "Sharing doesn't seem to work."
msgstr "Ez dirudi partekatzea dabilenik."

#: src/components/account-info.jsx:1414
#: src/components/status.jsx:1284
msgid "Share…"
msgstr "Partekatu…"

#: src/components/account-info.jsx:1434
msgid "Unmuted @{username}"
msgstr "@{username} mututzeari utzi zaio"

#: src/components/account-info.jsx:1446
msgid "Unmute <0>@{username}</0>"
msgstr "Utzi <0>@{username}</0> mututzeari"

#: src/components/account-info.jsx:1462
msgid "Mute <0>@{username}</0>…"
msgstr "Mututu <0>@{username}</0>…"

#. placeholder {0}: typeof MUTE_DURATIONS_LABELS[duration] === 'function' ? MUTE_DURATIONS_LABELS[duration]() : _(MUTE_DURATIONS_LABELS[duration])
#: src/components/account-info.jsx:1494
msgid "Muted @{username} for {0}"
msgstr "@{username} {0}rako mututu da"

#: src/components/account-info.jsx:1506
msgid "Unable to mute @{username}"
msgstr "Ezin da @{username} mututu"

#: src/components/account-info.jsx:1527
msgid "Remove <0>@{username}</0> from followers?"
msgstr "<0>@{username}</0> jarraitzaileetatik kendu nahi?"

#: src/components/account-info.jsx:1547
msgid "@{username} removed from followers"
msgstr "@{username} jarraitzaileetatik kendu da"

#: src/components/account-info.jsx:1559
msgid "Remove follower…"
msgstr "Kendu jarraitzailea…"

#: src/components/account-info.jsx:1570
msgid "Block <0>@{username}</0>?"
msgstr "<0>@{username}</0> blokeatu nahi?"

#: src/components/account-info.jsx:1594
msgid "Unblocked @{username}"
msgstr "@{username} blokeatzeari utzi zaio"

#: src/components/account-info.jsx:1602
msgid "Blocked @{username}"
msgstr "@{username} blokeatu da"

#: src/components/account-info.jsx:1610
msgid "Unable to unblock @{username}"
msgstr "Ezin da @{username} blokeatzeari utzi"

#: src/components/account-info.jsx:1612
msgid "Unable to block @{username}"
msgstr "Ezin da @{username} blokeatu"

#: src/components/account-info.jsx:1622
msgid "Unblock <0>@{username}</0>"
msgstr "Utzi <0>@{username}</0> blokeatzeari"

#: src/components/account-info.jsx:1631
msgid "Block <0>@{username}</0>…"
msgstr "Blokeatu <0>@{username}</0>…"

#: src/components/account-info.jsx:1648
msgid "Report <0>@{username}</0>…"
msgstr "Salatu <0>@{username}</0>…"

#: src/components/account-info.jsx:1704
msgid "Withdraw follow request?"
msgstr "Jarraipen-eskaera atzera bota?"

#. placeholder {0}: info.acct || info.username
#: src/components/account-info.jsx:1705
msgid "Unfollow @{0}?"
msgstr "Utzi @{0} jarraitzeari?"

#: src/components/account-info.jsx:1756
msgid "Unfollow…"
msgstr "Utzi jarraitzeari…"

#: src/components/account-info.jsx:1765
msgid "Withdraw…"
msgstr "Bota atzera…"

#: src/components/account-info.jsx:1772
#: src/components/account-info.jsx:1776
#: src/pages/hashtag.jsx:262
msgid "Follow"
msgstr "Jarraitu"

#: src/components/account-info.jsx:1873
#: src/components/account-info.jsx:1928
#: src/components/account-info.jsx:2062
#: src/components/account-info.jsx:2182
#: src/components/account-sheet.jsx:38
#: src/components/compose.jsx:881
#: src/components/compose.jsx:2728
#: src/components/compose.jsx:3202
#: src/components/compose.jsx:3411
#: src/components/compose.jsx:3641
#: src/components/drafts.jsx:59
#: src/components/embed-modal.jsx:13
#: src/components/generic-accounts.jsx:143
#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/list-add-edit.jsx:36
#: src/components/media-alt-modal.jsx:34
#: src/components/media-modal.jsx:322
#: src/components/notification-service.jsx:157
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:230
#: src/components/shortcuts-settings.jsx:583
#: src/components/shortcuts-settings.jsx:783
#: src/components/status.jsx:3083
#: src/components/status.jsx:3323
#: src/components/status.jsx:3832
#: src/pages/accounts.jsx:37
#: src/pages/catchup.jsx:1583
#: src/pages/filters.jsx:225
#: src/pages/list.jsx:276
#: src/pages/notifications.jsx:934
#: src/pages/scheduled-posts.jsx:257
#: src/pages/settings.jsx:87
#: src/pages/status.jsx:1319
msgid "Close"
msgstr "Itxi"

#: src/components/account-info.jsx:1878
msgid "Translated Bio"
msgstr "Itzulitako biografia"

#: src/components/account-info.jsx:1973
msgid "Unable to remove from list."
msgstr "Ezin da zerrendatik kendu."

#: src/components/account-info.jsx:1974
msgid "Unable to add to list."
msgstr "Ezin da zerrendara gehitu."

#: src/components/account-info.jsx:1993
#: src/pages/lists.jsx:105
msgid "Unable to load lists."
msgstr "Ezin dira zerrendak kargatu."

#: src/components/account-info.jsx:1997
msgid "No lists."
msgstr "Zerrendarik ez."

#: src/components/account-info.jsx:2008
#: src/components/list-add-edit.jsx:40
#: src/pages/lists.jsx:59
msgid "New list"
msgstr "Zerrenda berria"

#. placeholder {0}: account?.username || account?.acct
#: src/components/account-info.jsx:2067
msgid "Private note about <0>@{0}</0>"
msgstr "<0>@{0}</0>(r)i buruzko ohar pribatua"

#: src/components/account-info.jsx:2097
msgid "Unable to update private note."
msgstr "Ezin izan da ohar pribatua eguneratu."

#: src/components/account-info.jsx:2120
#: src/components/account-info.jsx:2418
msgid "Cancel"
msgstr "Utzi"

#: src/components/account-info.jsx:2125
msgid "Save & close"
msgstr "Gorde eta itxi"

#: src/components/account-info.jsx:2242
msgid "Unable to update profile."
msgstr "Ezin da profila eguneratu."

#: src/components/account-info.jsx:2249
msgid "Header picture"
msgstr "Goiburuko irudia"

#: src/components/account-info.jsx:2301
msgid "Profile picture"
msgstr "Profileko irudia"

#: src/components/account-info.jsx:2353
#: src/components/list-add-edit.jsx:105
msgid "Name"
msgstr "Izena"

#: src/components/account-info.jsx:2366
msgid "Bio"
msgstr "Biografia"

#: src/components/account-info.jsx:2379
msgid "Extra fields"
msgstr "Eremu gehigarriak"

#: src/components/account-info.jsx:2385
msgid "Label"
msgstr "Etiketa"

#: src/components/account-info.jsx:2388
msgid "Content"
msgstr "Edukia"

#: src/components/account-info.jsx:2421
#: src/components/list-add-edit.jsx:150
#: src/components/shortcuts-settings.jsx:715
#: src/pages/filters.jsx:570
#: src/pages/notifications.jsx:1000
msgid "Save"
msgstr "Gorde"

#: src/components/account-info.jsx:2475
msgid "username"
msgstr "erabiltzaile-izena"

#: src/components/account-info.jsx:2479
msgid "server domain name"
msgstr "zerbitzariaren domeinu-izena"

#: src/components/background-service.jsx:156
msgid "Cloak mode disabled"
msgstr "Estalki modua ezgaituta"

#: src/components/background-service.jsx:156
msgid "Cloak mode enabled"
msgstr "Estalki modua gaituta"

#: src/components/columns.jsx:27
#: src/components/nav-menu.jsx:176
#: src/components/shortcuts-settings.jsx:139
#: src/components/timeline.jsx:463
#: src/pages/catchup.jsx:882
#: src/pages/filters.jsx:90
#: src/pages/followed-hashtags.jsx:41
#: src/pages/home.jsx:54
#: src/pages/notifications.jsx:579
#: src/pages/scheduled-posts.jsx:72
msgid "Home"
msgstr "Hasiera"

#: src/components/compose-button.jsx:142
#: src/compose.jsx:38
msgid "Compose"
msgstr "Idatzi"

#: src/components/compose-button.jsx:169
#: src/components/nav-menu.jsx:260
#: src/pages/scheduled-posts.jsx:31
#: src/pages/scheduled-posts.jsx:76
msgid "Scheduled Posts"
msgstr "Programatutako bidalketak"

#: src/components/compose-button.jsx:182
msgid "Add to thread"
msgstr "Gehitu harira"

#: src/components/compose.jsx:211
msgid "Take photo or video"
msgstr "Egin argazkia edo bideoa"

#: src/components/compose.jsx:212
msgid "Add media"
msgstr "Gehitu multimedia"

#: src/components/compose.jsx:213
msgid "Add custom emoji"
msgstr "Gehitu emoji pertsonala"

#: src/components/compose.jsx:214
msgid "Add GIF"
msgstr "Gehitu GIFa"

#: src/components/compose.jsx:215
msgid "Add poll"
msgstr "Gehitu bozketa"

#: src/components/compose.jsx:216
msgid "Schedule post"
msgstr "Programatu bidalketa"

#: src/components/compose.jsx:415
msgid "You have unsaved changes. Discard this post?"
msgstr "Gorde gabeko aldaketak dituzu. Bidalketa zokoratu nahi duzu?"

#. placeholder {0}: unsupportedFiles.length
#. placeholder {1}: unsupportedFiles[0].name
#. placeholder {2}: lf.format( unsupportedFiles.map((f) => f.name), )
#: src/components/compose.jsx:644
msgid "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"
msgstr "{0, plural, one {{1} fitxategia ez da bateragarria.} other {{2} fitxategiak ez dira bateragarriak.}}"

#: src/components/compose.jsx:654
#: src/components/compose.jsx:672
#: src/components/compose.jsx:1777
#: src/components/compose.jsx:1902
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {Fitxategi bakarra erantsi dezakezu.} other {# fitxategi erantsi ditzakezu gehienez.}}"

#: src/components/compose.jsx:862
msgid "Pop out"
msgstr "Atera"

#: src/components/compose.jsx:869
msgid "Minimize"
msgstr "Ikonotu"

#: src/components/compose.jsx:905
msgid "Looks like you closed the parent window."
msgstr "Badirudi leiho nagusia itxi duzula."

#: src/components/compose.jsx:912
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Badirudi dagoeneko baduzula editorea irekita leiho nagusian eta zerbait argitaratzen ari zarela. Itxaron bukatu arte eta saiatu berriro geroago."

#: src/components/compose.jsx:917
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Badirudi dagoeneko baduzula editorea irekita leiho nagusian. Leiho berri bat ateraz gero, leiho nagusian egindako aldaketak zokoratuko dira. Jarraitu nahi duzu?"

#: src/components/compose.jsx:960
msgid "Pop in"
msgstr "Sartu"

#. placeholder {0}: replyToStatus.account.acct || replyToStatus.account.username
#. placeholder {1}: rtf.format(-replyToStatusMonthsAgo, 'month')
#: src/components/compose.jsx:970
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "@{0}(r)en bidalketari erantzuten (<0>{1}</0>)"

#. placeholder {0}: replyToStatus.account.acct || replyToStatus.account.username
#: src/components/compose.jsx:980
msgid "Replying to @{0}’s post"
msgstr "@{0}(r)en bidalketari erantzuten"

#: src/components/compose.jsx:993
msgid "Editing source post"
msgstr "Jatorrizko bidalketa editatzen"

#: src/components/compose.jsx:1046
msgid "Poll must have at least 2 options"
msgstr "Bozketak 2 aukera izan behar ditu gutxienez"

#: src/components/compose.jsx:1050
msgid "Some poll choices are empty"
msgstr "Bozketaren aukeretako batzuk hutsik daude"

#: src/components/compose.jsx:1063
msgid "Some media have no descriptions. Continue?"
msgstr "Ez dituzu multimedia fitxategi batzuk deskribatu. Jarraitu?"

#: src/components/compose.jsx:1115
msgid "Attachment #{i} failed"
msgstr "#{i} eranskinak huts egin du"

#: src/components/compose.jsx:1211
#: src/components/status.jsx:2156
#: src/components/timeline.jsx:1017
msgid "Content warning"
msgstr "Edukiari buruzko abisua"

#: src/components/compose.jsx:1227
msgid "Content warning or sensitive media"
msgstr "Edukiari buruzko abisua edo multimedia hunkigarria"

#: src/components/compose.jsx:1263
#: src/components/status.jsx:96
#: src/pages/settings.jsx:315
msgid "Public"
msgstr "Publikoa"

#: src/components/compose.jsx:1268
#: src/components/nav-menu.jsx:344
#: src/components/shortcuts-settings.jsx:165
#: src/components/status.jsx:97
msgid "Local"
msgstr "Lokala"

#: src/components/compose.jsx:1272
#: src/components/status.jsx:98
#: src/pages/settings.jsx:318
msgid "Unlisted"
msgstr "Zerrendatu gabea"

#: src/components/compose.jsx:1275
#: src/components/status.jsx:99
#: src/pages/settings.jsx:321
msgid "Followers only"
msgstr "Jarraitzaileentzat soilik"

#: src/components/compose.jsx:1278
#: src/components/status.jsx:100
#: src/components/status.jsx:2032
msgid "Private mention"
msgstr "Aipamen pribatua"

#: src/components/compose.jsx:1287
msgid "Post your reply"
msgstr "Argitaratu erantzuna"

#: src/components/compose.jsx:1289
msgid "Edit your post"
msgstr "Editatu bidalketa"

#: src/components/compose.jsx:1290
msgid "What are you doing?"
msgstr "Zertan zabiltza?"

#: src/components/compose.jsx:1368
msgid "Mark media as sensitive"
msgstr "Markatu multimedia hunkigarri gisa"

#: src/components/compose.jsx:1405
msgid "Posting on <0/>"
msgstr "Programatu <0/>"

#: src/components/compose.jsx:1436
#: src/components/compose.jsx:3260
#: src/components/shortcuts-settings.jsx:715
#: src/pages/list.jsx:362
msgid "Add"
msgstr "Gehitu"

#: src/components/compose.jsx:1662
msgid "Schedule"
msgstr "Programatu"

#: src/components/compose.jsx:1664
#: src/components/keyboard-shortcuts-help.jsx:155
#: src/components/status.jsx:1025
#: src/components/status.jsx:1806
#: src/components/status.jsx:1807
#: src/components/status.jsx:2492
msgid "Reply"
msgstr "Erantzun"

#: src/components/compose.jsx:1666
msgid "Update"
msgstr "Eguneratu"

#: src/components/compose.jsx:1667
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Argitaratu"

#: src/components/compose.jsx:1789
msgid "Downloading GIF…"
msgstr "GIFa deskargatzen…"

#: src/components/compose.jsx:1817
msgid "Failed to download GIF"
msgstr "Ezin da GIFa deskargatu"

#: src/components/compose.jsx:2032
#: src/components/compose.jsx:2109
#: src/components/nav-menu.jsx:239
msgid "More…"
msgstr "Gehiago…"

#: src/components/compose.jsx:2541
msgid "Uploaded"
msgstr "Igota"

#: src/components/compose.jsx:2554
msgid "Image description"
msgstr "Irudiaren deskribapena"

#: src/components/compose.jsx:2555
msgid "Video description"
msgstr "Bideoaren deskribapena"

#: src/components/compose.jsx:2556
msgid "Audio description"
msgstr "Audioaren deskribapena"

#. placeholder {0}: prettyBytes( imageSize, )
#. placeholder {0}: prettyBytes( videoSize, )
#. placeholder {1}: prettyBytes(imageSizeLimit)
#. placeholder {1}: prettyBytes(videoSizeLimit)
#: src/components/compose.jsx:2592
#: src/components/compose.jsx:2612
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "Fitxategia handiegia da. Igoerak arazoak izan ditzake. Saiatu tamaina {0}tik {1} edo gutxiagora murrizten."

#. placeholder {0}: i18n.number( width, )
#. placeholder {1}: i18n.number(height)
#. placeholder {2}: i18n.number(newWidth)
#. placeholder {3}: i18n.number( newHeight, )
#: src/components/compose.jsx:2604
#: src/components/compose.jsx:2624
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr ""

#: src/components/compose.jsx:2632
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Fotograma-tasa (frame rate) altuegia da. Igoerak arazoak izan ditzake."

#: src/components/compose.jsx:2692
#: src/components/compose.jsx:2942
#: src/components/shortcuts-settings.jsx:726
#: src/pages/catchup.jsx:1080
#: src/pages/filters.jsx:413
msgid "Remove"
msgstr "Kendu"

#: src/components/compose.jsx:2709
#: src/compose.jsx:84
msgid "Error"
msgstr "Errorea"

#: src/components/compose.jsx:2734
msgid "Edit image description"
msgstr "Editatu irudiaren deskribapena"

#: src/components/compose.jsx:2735
msgid "Edit video description"
msgstr "Editatu bideoaren deskribapena"

#: src/components/compose.jsx:2736
msgid "Edit audio description"
msgstr "Editatu audioaren deskribapena"

#: src/components/compose.jsx:2781
#: src/components/compose.jsx:2830
msgid "Generating description. Please wait…"
msgstr "Deskribapena sortzen. Itxaron…"

#. placeholder {0}: e.message
#: src/components/compose.jsx:2801
msgid "Failed to generate description: {0}"
msgstr ""

#: src/components/compose.jsx:2802
msgid "Failed to generate description"
msgstr "Ezin da deskribapena sortu"

#: src/components/compose.jsx:2814
#: src/components/compose.jsx:2820
#: src/components/compose.jsx:2866
msgid "Generate description…"
msgstr "Sortu deskribapena…"

#. placeholder {0}: e?.message ? `: ${e.message}` : ''
#: src/components/compose.jsx:2853
msgid "Failed to generate description{0}"
msgstr ""

#. placeholder {0}: localeCode2Text(lang)
#: src/components/compose.jsx:2868
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>— esperimentala</0>"

#: src/components/compose.jsx:2887
msgid "Done"
msgstr "Eginda"

#. placeholder {0}: i + 1
#: src/components/compose.jsx:2923
msgid "Choice {0}"
msgstr "{0}. aukera"

#: src/components/compose.jsx:2970
msgid "Multiple choices"
msgstr "Hainbat aukera"

#: src/components/compose.jsx:2973
msgid "Duration"
msgstr "Iraupena"

#: src/components/compose.jsx:3004
msgid "Remove poll"
msgstr "Kendu bozketa"

#: src/components/compose.jsx:3219
msgid "Search accounts"
msgstr "Bilatu kontuak"

#: src/components/compose.jsx:3273
#: src/components/generic-accounts.jsx:228
msgid "Error loading accounts"
msgstr "Errorea kontuak kargatzean"

#: src/components/compose.jsx:3417
msgid "Custom emojis"
msgstr "Instantziako emojiak"

#: src/components/compose.jsx:3437
msgid "Search emoji"
msgstr "Bilatu emojia"

#: src/components/compose.jsx:3468
msgid "Error loading custom emojis"
msgstr "Errorea emoji pertsonalizatua kargatzean"

#: src/components/compose.jsx:3479
msgid "Recently used"
msgstr "Oraintsu erabilita"

#: src/components/compose.jsx:3480
msgid "Others"
msgstr "Besteak"

#. placeholder {0}: i18n.number(emojis.length - max)
#: src/components/compose.jsx:3518
msgid "{0} more…"
msgstr "{0} gehiago…"

#: src/components/compose.jsx:3656
msgid "Search GIFs"
msgstr "Bilatu GIFak"

#: src/components/compose.jsx:3671
msgid "Powered by GIPHY"
msgstr "GIPHYri esker"

#: src/components/compose.jsx:3679
msgid "Type to search GIFs"
msgstr "Idatzi GIFak bilatzeko"

#: src/components/compose.jsx:3777
#: src/components/media-modal.jsx:464
#: src/components/timeline.jsx:921
msgid "Previous"
msgstr "Aurrekoa"

#: src/components/compose.jsx:3795
#: src/components/media-modal.jsx:483
#: src/components/timeline.jsx:938
msgid "Next"
msgstr "Hurrengoa"

#: src/components/compose.jsx:3812
msgid "Error loading GIFs"
msgstr "Errorea GIFak kargatzean"

#: src/components/drafts.jsx:64
#: src/pages/settings.jsx:701
msgid "Unsent drafts"
msgstr "Bidali gabeko zirriborroak"

#: src/components/drafts.jsx:69
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Badirudi bidali gabeko zirriborroak dituzula. Jarrai ezazu utzi zenuen tokian."

#: src/components/drafts.jsx:103
msgid "Delete this draft?"
msgstr "Zirriborroa ezabatu nahi duzu?"

#: src/components/drafts.jsx:118
msgid "Error deleting draft! Please try again."
msgstr "Errorea zirriborroa ezabatzean! Saiatu berriro."

#: src/components/drafts.jsx:128
#: src/components/list-add-edit.jsx:186
#: src/components/status.jsx:1428
#: src/pages/filters.jsx:603
#: src/pages/scheduled-posts.jsx:367
msgid "Delete…"
msgstr "Ezabatu…"

#: src/components/drafts.jsx:147
msgid "Error fetching reply-to status!"
msgstr "Errorea erantzuten ari zaion egoera eskuratzean!"

#: src/components/drafts.jsx:172
msgid "Delete all drafts?"
msgstr "Zirriborro guztiak ezabatu?"

#: src/components/drafts.jsx:190
msgid "Error deleting drafts! Please try again."
msgstr "Errorea zirriborroak ezabatzean! Saiatu berriro."

#: src/components/drafts.jsx:202
msgid "Delete all…"
msgstr "Ezabatu guztia…"

#: src/components/drafts.jsx:210
msgid "No drafts found."
msgstr "Ez dago zirriborrorik."

#: src/components/drafts.jsx:247
#: src/pages/catchup.jsx:1933
msgid "Poll"
msgstr "Bozketa"

#: src/components/drafts.jsx:250
#: src/pages/account-statuses.jsx:360
msgid "Media"
msgstr "Multimedia"

#: src/components/embed-modal.jsx:18
msgid "Open in new window"
msgstr "Ireki leiho berrian"

#: src/components/follow-request-buttons.jsx:43
#: src/pages/notifications.jsx:984
msgid "Accept"
msgstr "Onartu"

#: src/components/follow-request-buttons.jsx:69
msgid "Reject"
msgstr "Ukatu"

#: src/components/follow-request-buttons.jsx:76
#: src/pages/notifications.jsx:1268
msgid "Accepted"
msgstr "Onartuta"

#: src/components/follow-request-buttons.jsx:80
msgid "Rejected"
msgstr "Ukatuta"

#: src/components/generic-accounts.jsx:146
#: src/components/notification.jsx:445
#: src/pages/accounts.jsx:42
#: src/pages/search.jsx:331
#: src/pages/search.jsx:364
msgid "Accounts"
msgstr "Kontuak"

#: src/components/generic-accounts.jsx:206
#: src/components/timeline.jsx:545
#: src/pages/list.jsx:295
#: src/pages/notifications.jsx:914
#: src/pages/search.jsx:558
#: src/pages/status.jsx:1352
msgid "Show more…"
msgstr "Erakutsi gehiago…"

#: src/components/generic-accounts.jsx:211
#: src/components/timeline.jsx:550
#: src/pages/search.jsx:563
msgid "The end."
msgstr "Amaiera."

#: src/components/generic-accounts.jsx:232
msgid "Nothing to show"
msgstr "Ezertxo ere ez"

#: src/components/keyboard-shortcuts-help.jsx:47
#: src/components/nav-menu.jsx:363
#: src/pages/catchup.jsx:1621
msgid "Keyboard shortcuts"
msgstr "Laster-teklak"

#: src/components/keyboard-shortcuts-help.jsx:55
msgid "Keyboard shortcuts help"
msgstr "Teklatuko laster-teklen laguntza"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1646
msgid "Next post"
msgstr "Hurrengo bidalketa"

#: src/components/keyboard-shortcuts-help.jsx:63
#: src/pages/catchup.jsx:1654
msgid "Previous post"
msgstr "Aurreko bidalketa"

#: src/components/keyboard-shortcuts-help.jsx:67
msgid "Skip carousel to next post"
msgstr "Biratu karrusela hurrengora"

#: src/components/keyboard-shortcuts-help.jsx:69
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Shift</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:75
msgid "Skip carousel to previous post"
msgstr "Biratu karrusela aurrekora"

#: src/components/keyboard-shortcuts-help.jsx:77
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Shift</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:83
msgid "Load new posts"
msgstr "Kargatu bidalketa berriak"

#: src/components/keyboard-shortcuts-help.jsx:87
#: src/pages/catchup.jsx:1678
msgid "Open post details"
msgstr "Ireki bidalketaren xehetasunak"

#: src/components/keyboard-shortcuts-help.jsx:89
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Enter</0> or <1>o</1>"

#: src/components/keyboard-shortcuts-help.jsx:96
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Hedatu edukiaren abisua edo<0/>hedatu / tolestu haria"

#: src/components/keyboard-shortcuts-help.jsx:105
msgid "Close post or dialogs"
msgstr "Itxi bidalketa edo leihoa"

#: src/components/keyboard-shortcuts-help.jsx:107
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Esc</0> or <1>Backspace</1>"

#: src/components/keyboard-shortcuts-help.jsx:113
msgid "Focus column in multi-column mode"
msgstr "Fokatu zutabea zutabe anitzeko antolaketan"

#: src/components/keyboard-shortcuts-help.jsx:115
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> to <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Focus next column in multi-column mode"
msgstr "Fokatu hurrengo zutabean zutabe anitzeko antolaketan"

#: src/components/keyboard-shortcuts-help.jsx:125
msgid "Focus previous column in multi-column mode"
msgstr "Fokatu aurreko zutabean zutabe anitzeko antolaketan"

#: src/components/keyboard-shortcuts-help.jsx:129
msgid "Compose new post"
msgstr "Idatzi bidalketa berria"

#: src/components/keyboard-shortcuts-help.jsx:133
msgid "Compose new post (new window)"
msgstr "Idatzi bidalketa berria (leiho berria)"

#: src/components/keyboard-shortcuts-help.jsx:136
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Shift</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:142
msgid "Send post"
msgstr "Bidali"

#: src/components/keyboard-shortcuts-help.jsx:144
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"

#: src/components/keyboard-shortcuts-help.jsx:151
#: src/components/nav-menu.jsx:332
#: src/components/search-form.jsx:73
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:179
#: src/pages/search.jsx:46
#: src/pages/search.jsx:313
msgid "Search"
msgstr "Bilatu"

#: src/components/keyboard-shortcuts-help.jsx:159
msgid "Reply (new window)"
msgstr "Erantzun (leiho berria)"

#: src/components/keyboard-shortcuts-help.jsx:162
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Shift</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:168
msgid "Like (favourite)"
msgstr "Egin gogoko"

#: src/components/keyboard-shortcuts-help.jsx:170
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> edo <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:176
#: src/components/status.jsx:1033
#: src/components/status.jsx:2519
#: src/components/status.jsx:2542
#: src/components/status.jsx:2543
msgid "Boost"
msgstr "Bultzatu"

#: src/components/keyboard-shortcuts-help.jsx:178
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Shift</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:184
#: src/components/status.jsx:1096
#: src/components/status.jsx:2567
#: src/components/status.jsx:2568
msgid "Bookmark"
msgstr "Jarri laster-marka"

#: src/components/keyboard-shortcuts-help.jsx:188
msgid "Toggle Cloak mode"
msgstr "Estalki modua bai/ez"

#: src/components/keyboard-shortcuts-help.jsx:190
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Shift</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:40
msgid "Edit list"
msgstr "Editatu zerrenda"

#: src/components/list-add-edit.jsx:96
msgid "Unable to edit list."
msgstr "Ezin da zerrenda editatu."

#: src/components/list-add-edit.jsx:97
msgid "Unable to create list."
msgstr "Ezin da zerrenda sortu."

#: src/components/list-add-edit.jsx:125
msgid "Show replies to list members"
msgstr "Erakutsi zerrandako kideen erantzunak"

#: src/components/list-add-edit.jsx:128
msgid "Show replies to people I follow"
msgstr "Erakutsi erantzunak jarraitzen diedan pertsonei"

#: src/components/list-add-edit.jsx:131
msgid "Don't show replies"
msgstr "Ez erakutsi erantzunik"

#: src/components/list-add-edit.jsx:144
msgid "Hide posts on this list from Home/Following"
msgstr "Ezkutatu Hasiera / Jarraitzen -etik zerrenda honetako bidalketak"

#: src/components/list-add-edit.jsx:150
#: src/pages/filters.jsx:570
msgid "Create"
msgstr "Sortu"

#: src/components/list-add-edit.jsx:157
msgid "Delete this list?"
msgstr "Zerrenda ezabatu nahi duzu?"

#: src/components/list-add-edit.jsx:176
msgid "Unable to delete list."
msgstr "Ezin da zerrenda ezabatu."

#: src/components/media-alt-modal.jsx:39
#: src/components/media.jsx:51
msgid "Media description"
msgstr "Fitxategiaren deskribapena"

#: src/components/media-alt-modal.jsx:58
#: src/components/status.jsx:1139
#: src/components/status.jsx:1148
#: src/components/translation-block.jsx:235
msgid "Translate"
msgstr "Itzuli"

#: src/components/media-alt-modal.jsx:69
#: src/components/status.jsx:1167
msgid "Speak"
msgstr "Irakurri ozenki"

#: src/components/media-modal.jsx:369
msgid "Open original media in new window"
msgstr "Ireki jatorrizko multimedia fitxategia leiho berrian"

#: src/components/media-modal.jsx:373
msgid "Open original media"
msgstr "Ireki jatorrizko multimedia fitxategia"

#: src/components/media-modal.jsx:389
msgid "Attempting to describe image. Please wait…"
msgstr "Irudia deskribatzen saiatzen. Itxaron…"

#: src/components/media-modal.jsx:404
msgid "Failed to describe image"
msgstr "Ezin da irudia deskribatu"

#: src/components/media-modal.jsx:414
msgid "Describe image…"
msgstr "Deskribatu irudia…"

#: src/components/media-modal.jsx:438
msgid "View post"
msgstr "Ikusi bidalketa"

#: src/components/media-post.jsx:128
msgid "Sensitive media"
msgstr "Multimedia fitxategi hunkigarria"

#: src/components/media-post.jsx:133
msgid "Filtered: {filterTitleStr}"
msgstr "Iragazita: {filterTitleStr}"

#: src/components/media-post.jsx:134
#: src/components/status.jsx:3662
#: src/components/status.jsx:3758
#: src/components/status.jsx:3836
#: src/components/timeline.jsx:1006
#: src/pages/catchup.jsx:76
#: src/pages/catchup.jsx:1881
msgid "Filtered"
msgstr "Iragazita"

#: src/components/media.jsx:417
msgid "Open file"
msgstr "Ireki fitxategia"

#: src/components/modals.jsx:75
msgid "Post scheduled"
msgstr "Programatutako bidalketa"

#: src/components/modals.jsx:76
msgid "Post published. Check it out."
msgstr "Bidalketa argitaratu da. Ikus ezazu."

#: src/components/modals.jsx:78
msgid "Reply scheduled"
msgstr "Programatutako erantzuna"

#: src/components/modals.jsx:79
msgid "Reply posted. Check it out."
msgstr "Erantzuna argitaratu da. Ikus ezazu."

#: src/components/modals.jsx:80
msgid "Post updated. Check it out."
msgstr "Bidalketa eguneratu da. Ikus ezazu."

#: src/components/nav-menu.jsx:118
msgid "Menu"
msgstr "Menua"

#: src/components/nav-menu.jsx:154
msgid "Reload page now to update?"
msgstr "Birkargatu orria orain eguneratzeko?"

#: src/components/nav-menu.jsx:166
msgid "New update available…"
msgstr "Eguneraketa eskuragarri…"

#. js-lingui-explicit-id
#: src/components/nav-menu.jsx:185
#: src/components/shortcuts-settings.jsx:140
#: src/pages/following.jsx:23
#: src/pages/following.jsx:142
msgid "following.title"
msgstr "Jarraitzen ditu"

#: src/components/nav-menu.jsx:192
#: src/pages/catchup.jsx:877
msgid "Catch-up"
msgstr "Zer berri?"

#: src/components/nav-menu.jsx:199
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:146
#: src/pages/home.jsx:228
#: src/pages/mentions.jsx:21
#: src/pages/mentions.jsx:168
#: src/pages/settings.jsx:1151
#: src/pages/trending.jsx:379
msgid "Mentions"
msgstr "Aipamenak"

#: src/components/nav-menu.jsx:206
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:152
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:86
#: src/pages/home.jsx:186
#: src/pages/notifications.jsx:114
#: src/pages/notifications.jsx:583
msgid "Notifications"
msgstr "Jakinarazpenak"

#: src/components/nav-menu.jsx:209
msgid "New"
msgstr "Berria"

#: src/components/nav-menu.jsx:220
msgid "Profile"
msgstr "Profila"

#: src/components/nav-menu.jsx:228
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:195
#: src/pages/bookmarks.jsx:12
#: src/pages/bookmarks.jsx:24
msgid "Bookmarks"
msgstr "Laster-markak"

#: src/components/nav-menu.jsx:248
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:201
#: src/pages/catchup.jsx:1448
#: src/pages/catchup.jsx:2068
#: src/pages/favourites.jsx:12
#: src/pages/favourites.jsx:24
#: src/pages/settings.jsx:1155
msgid "Likes"
msgstr "Gogokoak"

#: src/components/nav-menu.jsx:254
#: src/pages/followed-hashtags.jsx:15
#: src/pages/followed-hashtags.jsx:45
msgid "Followed Hashtags"
msgstr "Jarraitutako traolak"

#: src/components/nav-menu.jsx:268
#: src/pages/account-statuses.jsx:326
#: src/pages/filters.jsx:55
#: src/pages/filters.jsx:94
#: src/pages/hashtag.jsx:340
msgid "Filters"
msgstr "Iragazkiak"

#: src/components/nav-menu.jsx:276
msgid "Muted users"
msgstr "Mutututako erabiltzaileak"

#: src/components/nav-menu.jsx:284
msgid "Muted users…"
msgstr "Mutututakoak…"

#: src/components/nav-menu.jsx:291
msgid "Blocked users"
msgstr "Blokeatutako erabiltzaileak"

#: src/components/nav-menu.jsx:299
msgid "Blocked users…"
msgstr "Blokeatutakoak…"

#: src/components/nav-menu.jsx:311
msgid "Accounts…"
msgstr "Kontuak…"

#: src/components/nav-menu.jsx:321
#: src/pages/login.jsx:27
#: src/pages/login.jsx:190
#: src/pages/status.jsx:855
#: src/pages/welcome.jsx:65
msgid "Log in"
msgstr "Hasi saioa"

#: src/components/nav-menu.jsx:338
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:172
#: src/pages/trending.jsx:439
msgid "Trending"
msgstr "Joerak"

#: src/components/nav-menu.jsx:350
#: src/components/shortcuts-settings.jsx:165
msgid "Federated"
msgstr "Federatua"

#: src/components/nav-menu.jsx:373
msgid "Shortcuts / Columns…"
msgstr "Lasterbideak / Zutabeak…"

#: src/components/nav-menu.jsx:383
#: src/components/nav-menu.jsx:397
msgid "Settings…"
msgstr "Ezarpenak…"

#: src/components/nav-menu.jsx:427
#: src/components/nav-menu.jsx:454
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:158
#: src/pages/list.jsx:127
#: src/pages/lists.jsx:17
#: src/pages/lists.jsx:51
msgid "Lists"
msgstr "Zerrendak"

#: src/components/nav-menu.jsx:435
#: src/components/shortcuts.jsx:214
#: src/pages/list.jsx:134
msgid "All Lists"
msgstr "Zerrenda guztiak"

#: src/components/notification-service.jsx:161
msgid "Notification"
msgstr "Jakinarazpenak"

#: src/components/notification-service.jsx:167
msgid "This notification is from your other account."
msgstr "Jakinarazpena zure beste kontuarena da."

#: src/components/notification-service.jsx:196
msgid "View all notifications"
msgstr "Ikusi jakinarazpen guztiak"

#: src/components/notification.jsx:71
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account}(e)k zure bidalketari {emojiObject}rekin erantzun dio"

#: src/components/notification.jsx:78
msgid "{account} published a post."
msgstr "{account}(e)k bidalketa bat argitaratu du"

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:86
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account}(e)k zure erantzuna bultzatu du.} other {{account}(e)k zure bidalketa bultzatu du.}}} other {{account}(e)k zure {postsCount} bidalketa bultzatu ditu.}}} other {{postType, select, reply {<0><1>{0}</1> pertsonak</0> zure erantzuna bultzatu dute.} other {<2><3>{1}</3> pertsonak</2> zure bidalketa bultzatu dute.}}}}"

#. placeholder {0}: shortenNumber(count)
#: src/components/notification.jsx:129
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, one {}=1 {{account}(e)k jarraitu dizu.} other {<0><1>{0}</1> pertsonak</0> jarraitu dizute.}}"

#: src/components/notification.jsx:143
msgid "{account} requested to follow you."
msgstr "{account}(e)k jarraitzeko eskaera egin dizu."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:152
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account}(e)k zure erantzuna gogoko du.} other {{account}(e)k zure bidalketa gogoko du.}}} other {{account}(e)k zure {postsCount} bidalketa gogoko ditu.}}} other {{postType, select, reply {<0><1>{0}</1> pertsonak</0> zure erantzuna gogoko dute.} other {<2><3>{1}</3> pertsonak</2> zure bidalketa gogoko dute.}}}}"

#: src/components/notification.jsx:194
msgid "A poll you have voted in or created has ended."
msgstr "Sortu edo boza eman zenuen bozketa bat amaitu da."

#: src/components/notification.jsx:195
msgid "A poll you have created has ended."
msgstr "Sortu zenuen bozketa bat amaitu da."

#: src/components/notification.jsx:196
msgid "A poll you have voted in has ended."
msgstr "Boza eman zenuen bozketa bat amaitu da."

#: src/components/notification.jsx:197
msgid "A post you interacted with has been edited."
msgstr "Interaktuatu zenuen bidalketa bat editatu dute."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:205
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account}(e)ek zure erantzuna gogoko egin eta bultzatu du.} other {{account}(e)ek zure bidalketa gogoko egin eta bultzatu du.}}} other {{account}(e)k (e)ek zure  {postsCount} bidalketa gogoko egin eta bultzatu ditu.}}} other {{postType, select, reply {<0><1>{0}</1> pertsonak</0> erantzuna gogoko egin eta bultzatu dute.} other {<2><3>{1}</3> pertsonak</2> zure bidalketa gogoko egin eta bultzatu dute.}}}}"

#: src/components/notification.jsx:247
msgid "{account} signed up."
msgstr "{account}(e)k izena eman du."

#: src/components/notification.jsx:249
msgid "{account} reported {targetAccount}"
msgstr "{account}(e)k {targetAccount} salatu du"

#: src/components/notification.jsx:254
msgid "Lost connections with <0>{name}</0>."
msgstr "<0>{name}</0>(r)ekin harremana galdu da."

#: src/components/notification.jsx:260
msgid "Moderation warning"
msgstr "Moderazio-ohartarazpena"

#: src/components/notification.jsx:265
msgid "Your {year} #Wrapstodon is here!"
msgstr "Hemen da {year}ko #Wrapstodon!"

#: src/components/notification.jsx:271
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "<0>{from}</0>(e)ko administratzaile batek <1>{targetName}</1> bertan behera utzi du, eta horrek esan nahi du aurrerantzean ezingo duzula harekin harremanik izan."

#: src/components/notification.jsx:277
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "<0>{from}</0>(e)ko administratzaile batek <1>{targetName}</1> blokeatu du. Eragina du jarraitzen dizuten {followersCount} eta jarraitzen dituzun {followingCount} -engan."

#: src/components/notification.jsx:283
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "<0>{targetName}</0> blokeatu duzu. Jarraitzen zizuten {followersCount} eta jarraitzen zenituen {followingCount} kendu dira."

#: src/components/notification.jsx:291
msgid "Your account has received a moderation warning."
msgstr "Zure kontuak moderazio-ohartarazpen bat jaso du."

#: src/components/notification.jsx:292
msgid "Your account has been disabled."
msgstr "Zure kontua ezgaitu da."

#: src/components/notification.jsx:293
msgid "Some of your posts have been marked as sensitive."
msgstr "Zure bidalketa batzuk hunkigarri gisa markatu dira."

#: src/components/notification.jsx:294
msgid "Some of your posts have been deleted."
msgstr "Zure bidalketa batzuk ezabatu dira."

#: src/components/notification.jsx:295
msgid "Your posts will be marked as sensitive from now on."
msgstr "Aurrerantzean zure bidalketak hunkigarri gisa markatuko dira."

#: src/components/notification.jsx:296
msgid "Your account has been limited."
msgstr "Zure kontuari mugak jarri zaizkio."

#: src/components/notification.jsx:297
msgid "Your account has been suspended."
msgstr "Zure kontua bertan behera utzi da."

#: src/components/notification.jsx:372
msgid "[Unknown notification type: {type}]"
msgstr "[Jakinarazpen mota ezezaguna: {type}]"

#: src/components/notification.jsx:441
#: src/components/status.jsx:1110
#: src/components/status.jsx:1120
msgid "Boosted/Liked by…"
msgstr "Bultzatu/Gogoko du(te)…"

#: src/components/notification.jsx:442
msgid "Liked by…"
msgstr "Gogoko du…"

#: src/components/notification.jsx:443
msgid "Boosted by…"
msgstr "Bultzatu du…"

#: src/components/notification.jsx:444
msgid "Followed by…"
msgstr "Jarraitzen dizu…"

#: src/components/notification.jsx:514
#: src/components/notification.jsx:530
msgid "Learn more <0/>"
msgstr "Ikasi gehiago <0/>"

#: src/components/notification.jsx:539
msgid "View #Wrapstodon"
msgstr "Ikusi #Wrapstodon"

#: src/components/notification.jsx:772
#: src/components/status.jsx:316
msgid "Read more →"
msgstr "Irakurri gehiago →"

#: src/components/poll.jsx:113
msgid "Voted"
msgstr "Bozkatu duzu"

#: src/components/poll.jsx:119
msgid "{optionVotesCount, plural, one {# vote} other {# votes}}"
msgstr "{optionVotesCount, plural, one {boto #} other {# boto}}"

#: src/components/poll.jsx:139
#: src/components/poll.jsx:222
#: src/components/poll.jsx:226
msgid "Hide results"
msgstr "Ezkutatu emaitzak"

#: src/components/poll.jsx:188
msgid "Vote"
msgstr "Bozkatu"

#: src/components/poll.jsx:208
#: src/components/poll.jsx:210
#: src/pages/scheduled-posts.jsx:98
#: src/pages/status.jsx:1221
#: src/pages/status.jsx:1244
msgid "Refresh"
msgstr "Freskatu"

#: src/components/poll.jsx:222
#: src/components/poll.jsx:226
msgid "Show results"
msgstr "Erakutsi emaitzak"

#. placeholder {0}: shortenNumber(votesCount)
#. placeholder {1}: shortenNumber(votesCount)
#: src/components/poll.jsx:231
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {boto <0>{0}</0>} other {<1>{1}</1> boto}}"

#. placeholder {0}: shortenNumber(votersCount)
#. placeholder {1}: shortenNumber(votersCount)
#: src/components/poll.jsx:248
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {hautesle <0>{0}</0>} other {<1>{1}</1> hautesle}}"

#: src/components/poll.jsx:268
msgid "Ended <0/>"
msgstr "<0/> amaitu da"

#: src/components/poll.jsx:272
msgid "Ended"
msgstr "Amaitu da"

#: src/components/poll.jsx:275
msgid "Ending <0/>"
msgstr "<0/> amaituko da"

#: src/components/poll.jsx:279
msgid "Ending"
msgstr "Amaiera-data"

#. Relative time in seconds, as short as possible
#. placeholder {0}: seconds < 1 ? 1 : Math.floor(seconds)
#: src/components/relative-time.jsx:59
msgid "{0}s"
msgstr "{0}s"

#. Relative time in minutes, as short as possible
#. placeholder {0}: Math.floor(seconds / minute)
#: src/components/relative-time.jsx:64
msgid "{0}m"
msgstr "{0}m"

#. Relative time in hours, as short as possible
#. placeholder {0}: Math.floor(seconds / hour)
#: src/components/relative-time.jsx:69
msgid "{0}h"
msgstr "{0}h"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "Mezu baztergarria"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "Esteka maltzurrak, gezurrezko elkarrekintzak edo erantzun errepikakorrak"

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "Legez kanpokoa"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr "Zure edo zerbitzariaren herrialdeko legedia urratzen du"

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr "Zerbitzariaren arauen urraketa"

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "Zerbitzariaren arau jakinak urratzen ditu"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "Urraketa"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "Beste zerbait"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr "Arazoa ez dator bat beste kategoriekin"

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "Salatu bidalketa"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "Salatu @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "Berrikusketeke"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "Bidalketa salatu da"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "Profila salatu da"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "Ezin da bidalketa salatu"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "Ezin da profila salatu"

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "Zein da bidalketaren arazoa?"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "Zein da profilaren arazoa?"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "Informazio gehigarria"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "Birbidali <0>{domain}</0>(e)ra"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "Bidali salaketa"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "{username} mutututa"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr "Ezin da {username} mututu"

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr "Bidali salaketa <0>+ Mututu profila</0>"

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "{username} blokeatuta"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "Ezin da {username} blokeatu"

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "Bidali salaketa <0>+ Blokeatu profila</0>"

#: src/components/search-form.jsx:203
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ kontuak, traolak eta bidalketak</0>"

#: src/components/search-form.jsx:216
msgid "Posts with <0>{query}</0>"
msgstr "<0>{query}</0> duten bidalketak"

#. placeholder {0}: query.replace(/^#/, '')
#: src/components/search-form.jsx:228
msgid "Posts tagged with <0>#{0}</0>"
msgstr "<0>#{0}</0>(r)ekin etiketatutako bidalketak"

#: src/components/search-form.jsx:242
msgid "Look up <0>{query}</0>"
msgstr "Bilatu <0>{query}</0>"

#: src/components/search-form.jsx:253
msgid "Accounts with <0>{query}</0>"
msgstr "<0>{query}</0> duten kontuak"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "Hasiera / Jarraitzen"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "Publikoa (Lokala / Federatua)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "Kontua"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "Traolak"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "Zerrendaren IDa"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Lokala bakarrik"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:194
msgid "Instance"
msgstr "Instantzia"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "Aukerakoa, adib. mastodon.eus"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "Bilatzeko terminoa"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "Aukerakoa, zutabe anitzeko antolaketa erabili ezean"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "adib. PixelArt (5 gehienez, espazioen bidez bereizita)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:356
msgid "Media only"
msgstr "Multimedia bakarrik"

#: src/components/shortcuts-settings.jsx:235
#: src/components/shortcuts.jsx:191
msgid "Shortcuts"
msgstr "Lasterbideak"

#: src/components/shortcuts-settings.jsx:243
msgid "beta"
msgstr "beta"

#: src/components/shortcuts-settings.jsx:249
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "Zehaztu lasterbideen zerrenda bat honela agertzeko:"

#: src/components/shortcuts-settings.jsx:255
msgid "Floating button"
msgstr "Botoi mugikorra"

#: src/components/shortcuts-settings.jsx:260
msgid "Tab/Menu bar"
msgstr "Erlaitz- / Menu-barra"

#: src/components/shortcuts-settings.jsx:265
msgid "Multi-column"
msgstr "Zutabe anitz"

#: src/components/shortcuts-settings.jsx:332
msgid "Not available in current view mode"
msgstr "Ez dago erabilgarri uneko ikuspegian"

#: src/components/shortcuts-settings.jsx:351
msgid "Move up"
msgstr "Mugitu gora"

#: src/components/shortcuts-settings.jsx:367
msgid "Move down"
msgstr "Mugitu behera"

#: src/components/shortcuts-settings.jsx:379
#: src/components/status.jsx:1390
#: src/pages/list.jsx:171
msgid "Edit"
msgstr "Editatu"

#: src/components/shortcuts-settings.jsx:400
msgid "Add more than one shortcut/column to make this work."
msgstr "Gehitu lasterbide / zutabe bat baino gehiago erabili ahal izateko."

#: src/components/shortcuts-settings.jsx:411
msgid "No columns yet. Tap on the Add column button."
msgstr "Oraindik ez dago zutaberik. Egin tap Gehitu zutabea botoian."

#: src/components/shortcuts-settings.jsx:412
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "Oraindik ez dago lasterbiderik. Egin tap Gehitu lasterbidea botoian."

#: src/components/shortcuts-settings.jsx:415
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "Ez dakizu zer gehitu?<0/>Probatu <1>Hasiera / Jarraitzen eta Jakinarazpenak</1>."

#: src/components/shortcuts-settings.jsx:443
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "{SHORTCUTS_LIMIT} zutabe gehienez"

#: src/components/shortcuts-settings.jsx:444
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "{SHORTCUTS_LIMIT} lasterbide gehienez"

#: src/components/shortcuts-settings.jsx:458
msgid "Import/export"
msgstr "Inportatu / esportatu"

#: src/components/shortcuts-settings.jsx:468
msgid "Add column…"
msgstr "Gehitu zutabea…"

#: src/components/shortcuts-settings.jsx:469
msgid "Add shortcut…"
msgstr "Gehitu lasterbidea…"

#: src/components/shortcuts-settings.jsx:516
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "Zerrenda zehatza aukerakoa da. Zutabe anitzeko antolaketan zerrenda beharrezkoa da, bestela zutabea ez da erakutsiko."

#: src/components/shortcuts-settings.jsx:517
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "Zutabe anitzeko antolaketan bilatzeko terminoa beharrezkoa da, bestela zutabea ez da erakutsiko."

#: src/components/shortcuts-settings.jsx:518
msgid "Multiple hashtags are supported. Space-separated."
msgstr "Traola bat baino gehiago onartzen dira. Espazioen bidez bereizita."

#: src/components/shortcuts-settings.jsx:587
msgid "Edit shortcut"
msgstr "Editatu lasterbidea"

#: src/components/shortcuts-settings.jsx:587
msgid "Add shortcut"
msgstr "Gehitu lasterbidea"

#: src/components/shortcuts-settings.jsx:623
msgid "Timeline"
msgstr "Denbora-lerroa"

#: src/components/shortcuts-settings.jsx:649
msgid "List"
msgstr "Zerrenda"

#: src/components/shortcuts-settings.jsx:788
msgid "Import/Export <0>Shortcuts</0>"
msgstr "Inportatu / Esportatu <0>Lasterbideak</0>"

#: src/components/shortcuts-settings.jsx:798
msgid "Import"
msgstr "Inportatu"

#: src/components/shortcuts-settings.jsx:806
msgid "Paste shortcuts here"
msgstr "Itsatsi lasterbideak hemen"

#: src/components/shortcuts-settings.jsx:822
msgid "Downloading saved shortcuts from instance server…"
msgstr "Gordetako lasterbideak zerbitzaritik deskargatzen…"

#: src/components/shortcuts-settings.jsx:851
msgid "Unable to download shortcuts"
msgstr "Ezin dira lasterbideak deskargatu"

#: src/components/shortcuts-settings.jsx:854
msgid "Download shortcuts from instance server"
msgstr "Deskargatu lasterbideak zerbitzaritik"

#: src/components/shortcuts-settings.jsx:912
msgid "* Exists in current shortcuts"
msgstr "* Lasterbidea badago lehendik ere"

#: src/components/shortcuts-settings.jsx:917
msgid "List may not work if it's from a different account."
msgstr "Litekeena da zerrendak ezin erabiltzea beste kontu batekoak badira."

#: src/components/shortcuts-settings.jsx:927
msgid "Invalid settings format"
msgstr "Ezarpenen formatu baliogabea"

#: src/components/shortcuts-settings.jsx:935
msgid "Append to current shortcuts?"
msgstr "Gehitu uneko lasterbideei?"

#: src/components/shortcuts-settings.jsx:938
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr "Uneko lasterbideetan ez daudenak gehituko dira soilik."

#: src/components/shortcuts-settings.jsx:960
msgid "No new shortcuts to import"
msgstr "Ez dago inportatzeko lasterbide berririk"

#: src/components/shortcuts-settings.jsx:975
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Lasterbideak inportatu dira. {SHORTCUTS_LIMIT} muga gainditu da, gainerakoak ez dira inportatuko."

#: src/components/shortcuts-settings.jsx:976
#: src/components/shortcuts-settings.jsx:1000
msgid "Shortcuts imported"
msgstr "Lasterbideak inportatu dira"

#: src/components/shortcuts-settings.jsx:986
msgid "Import & append…"
msgstr "Inportatu eta gehitu…"

#: src/components/shortcuts-settings.jsx:994
msgid "Override current shortcuts?"
msgstr "Uneko lasterbideak gainidatzi?"

#: src/components/shortcuts-settings.jsx:995
msgid "Import shortcuts?"
msgstr "Lasterbideak inportatu?"

#: src/components/shortcuts-settings.jsx:1009
msgid "or override…"
msgstr "edo gainidatzi…"

#: src/components/shortcuts-settings.jsx:1009
msgid "Import…"
msgstr "Inportatu…"

#: src/components/shortcuts-settings.jsx:1018
msgid "Export"
msgstr "Esportatu"

#: src/components/shortcuts-settings.jsx:1033
msgid "Shortcuts copied"
msgstr "Lasterbideak kopiatu dira"

#: src/components/shortcuts-settings.jsx:1036
msgid "Unable to copy shortcuts"
msgstr "Ezin dira lasterbideak kopiatu"

#: src/components/shortcuts-settings.jsx:1050
msgid "Shortcut settings copied"
msgstr "Lasterbideen ezarpenak kopiatu dira"

#: src/components/shortcuts-settings.jsx:1053
msgid "Unable to copy shortcut settings"
msgstr "Ezin dira lasterbideen ezarpenak kopiatu"

#: src/components/shortcuts-settings.jsx:1083
msgid "Share"
msgstr "Partekatu"

#: src/components/shortcuts-settings.jsx:1122
msgid "Saving shortcuts to instance server…"
msgstr "Lasterbideak zerbitzarian gordetzen…"

#: src/components/shortcuts-settings.jsx:1129
msgid "Shortcuts saved"
msgstr "Lasterbideak gorde dira"

#: src/components/shortcuts-settings.jsx:1134
msgid "Unable to save shortcuts"
msgstr "Ezin dira lasterbideak gorde"

#: src/components/shortcuts-settings.jsx:1137
msgid "Sync to instance server"
msgstr "Sinkronizatu zerbitzariarekin"

#. placeholder {0}: shortcutsStr.length
#: src/components/shortcuts-settings.jsx:1145
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0, plural, one {karaktere #} other {# karaktere}}"

#: src/components/shortcuts-settings.jsx:1157
msgid "Raw Shortcuts JSON"
msgstr "Lasterbideen JSON gordina"

#: src/components/shortcuts-settings.jsx:1170
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "Inportatu / Esportatu ezarpenak zerbitzarira / zerbitzaritik (oso esperimentala)"

#: src/components/status.jsx:612
msgid "<0/> <1>boosted</1>"
msgstr "<0/>(e)k <1>bultzatua</1>"

#: src/components/status.jsx:711
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "Barka baina saioa hasita duzun zerbitzariak ezin du interaktuatu beste instantzia batekoa den bidalketa honekin."

#. placeholder {0}: username || acct
#: src/components/status.jsx:864
msgid "Unliked @{0}'s post"
msgstr "@{0}(r)en bidalketa gogoko izateari utzi diozu"

#. placeholder {0}: username || acct
#: src/components/status.jsx:865
msgid "Liked @{0}'s post"
msgstr ""

#. placeholder {0}: username || acct
#: src/components/status.jsx:904
msgid "Unbookmarked @{0}'s post"
msgstr ""

#. placeholder {0}: username || acct
#: src/components/status.jsx:905
msgid "Bookmarked @{0}'s post"
msgstr ""

#: src/components/status.jsx:1002
msgid "Some media have no descriptions."
msgstr "Multimedia fitxategi batzuek ez dute deskribapenik."

#. placeholder {0}: rtf.format(-statusMonthsAgo, 'month')
#: src/components/status.jsx:1009
msgid "Old post (<0>{0}</0>)"
msgstr "Bidalketa zaharra (<0>{0}</0>)"

#: src/components/status.jsx:1033
#: src/components/status.jsx:1073
#: src/components/status.jsx:2519
#: src/components/status.jsx:2542
msgid "Unboost"
msgstr "Kendu bultzada"

#: src/components/status.jsx:1049
#: src/components/status.jsx:2534
msgid "Quote"
msgstr "Aipatu"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1061
#: src/components/status.jsx:1524
msgid "Unboosted @{0}'s post"
msgstr ""

#. placeholder {0}: username || acct
#: src/components/status.jsx:1062
#: src/components/status.jsx:1525
msgid "Boosted @{0}'s post"
msgstr ""

#: src/components/status.jsx:1074
msgid "Boost…"
msgstr "Bultzatu…"

#: src/components/status.jsx:1086
#: src/components/status.jsx:1816
#: src/components/status.jsx:2555
msgid "Unlike"
msgstr "Utzi gogoko egiteari"

#: src/components/status.jsx:1087
#: src/components/status.jsx:1816
#: src/components/status.jsx:1817
#: src/components/status.jsx:2555
#: src/components/status.jsx:2556
msgid "Like"
msgstr "Gogoko egin"

#: src/components/status.jsx:1096
#: src/components/status.jsx:2567
msgid "Unbookmark"
msgstr "Kendu laster-marka"

#: src/components/status.jsx:1179
msgid "Post text copied"
msgstr ""

#: src/components/status.jsx:1182
msgid "Unable to copy post text"
msgstr ""

#: src/components/status.jsx:1188
msgid "Copy post text"
msgstr ""

#. placeholder {0}: username || acct
#: src/components/status.jsx:1206
msgid "View post by <0>@{0}</0>"
msgstr "Ikusi <0>@{0}</0>(r)en bidalketa"

#: src/components/status.jsx:1227
msgid "Show Edit History"
msgstr "Erakutsi edizio-historia"

#: src/components/status.jsx:1230
msgid "Edited: {editedDateText}"
msgstr "Editatuta: {editedDateText}"

#: src/components/status.jsx:1297
#: src/components/status.jsx:3328
msgid "Embed post"
msgstr "Txertatu bidalketa"

#: src/components/status.jsx:1311
msgid "Conversation unmuted"
msgstr "Elkarrizketa mututzeari utzi zaio"

#: src/components/status.jsx:1311
msgid "Conversation muted"
msgstr "Elkarrizketa mututu da"

#: src/components/status.jsx:1317
msgid "Unable to unmute conversation"
msgstr "Ezin da elkarrizketa mututzeari utzi"

#: src/components/status.jsx:1318
msgid "Unable to mute conversation"
msgstr "Ezin da elkarrizketa mututu"

#: src/components/status.jsx:1327
msgid "Unmute conversation"
msgstr "Utzi elkarrizketa mututzeari"

#: src/components/status.jsx:1334
msgid "Mute conversation"
msgstr "Mututu elkarrizketa"

#: src/components/status.jsx:1350
msgid "Post unpinned from profile"
msgstr "Bidalketa profilean finkatzeari utzi zaio"

#: src/components/status.jsx:1351
msgid "Post pinned to profile"
msgstr "Profilean finkatutako bidalketa"

#: src/components/status.jsx:1356
msgid "Unable to unpin post"
msgstr "Ezin da bidalketa finkatzeari utzi"

#: src/components/status.jsx:1356
msgid "Unable to pin post"
msgstr "Ezin da bidalketa finkatu"

#: src/components/status.jsx:1365
msgid "Unpin from profile"
msgstr "Utzi profilean finkatzeari"

#: src/components/status.jsx:1372
msgid "Pin to profile"
msgstr "Finkatu profilean"

#: src/components/status.jsx:1401
msgid "Delete this post?"
msgstr "Bidalketa ezabatu nahi duzu?"

#: src/components/status.jsx:1417
msgid "Post deleted"
msgstr "Bidalketa ezabatu da"

#: src/components/status.jsx:1420
msgid "Unable to delete post"
msgstr "Ezin da bidalketa ezabatu"

#: src/components/status.jsx:1448
msgid "Report post…"
msgstr "Salatu bidalketa…"

#: src/components/status.jsx:1817
#: src/components/status.jsx:1853
#: src/components/status.jsx:2556
msgid "Liked"
msgstr "Gogoko egina"

#: src/components/status.jsx:1850
#: src/components/status.jsx:2543
msgid "Boosted"
msgstr "Bultzatua"

#: src/components/status.jsx:1860
#: src/components/status.jsx:2568
msgid "Bookmarked"
msgstr "Laster-marka jarria"

#: src/components/status.jsx:1864
msgid "Pinned"
msgstr "Finkatua"

#: src/components/status.jsx:1910
#: src/components/status.jsx:2380
msgid "Deleted"
msgstr "Ezabatua"

#: src/components/status.jsx:1951
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {erantzun #} other {# erantzun}}"

#. placeholder {0}: snapStates.statusThreadNumber[sKey] ? ` ${snapStates.statusThreadNumber[sKey]}/X` : ''
#: src/components/status.jsx:2041
msgid "Thread{0}"
msgstr "Haria{0}"

#: src/components/status.jsx:2119
#: src/components/status.jsx:2181
#: src/components/status.jsx:2276
msgid "Show less"
msgstr "Ezkutatu edukia"

#: src/components/status.jsx:2119
#: src/components/status.jsx:2181
msgid "Show content"
msgstr "Erakutsi edukia"

#. placeholder {0}: filterInfo.titlesStr
#. placeholder {0}: filterInfo?.titlesStr
#: src/components/status.jsx:2272
#: src/pages/catchup.jsx:1880
msgid "Filtered: {0}"
msgstr "Iragazita: {0}"

#: src/components/status.jsx:2276
msgid "Show media"
msgstr "Erakutsi multimedia fitxategiak"

#: src/components/status.jsx:2416
msgid "Edited"
msgstr "Editatuta"

#: src/components/status.jsx:2493
msgid "Comments"
msgstr "Iruzkinak"

#. More from [Author]
#: src/components/status.jsx:2786
msgid "More from <0/>"
msgstr "<0/>(r)en gehiago"

#: src/components/status.jsx:3088
msgid "Edit History"
msgstr "Edizio-historia"

#: src/components/status.jsx:3092
msgid "Failed to load history"
msgstr "Ezin da historia kargatu"

#: src/components/status.jsx:3097
#: src/pages/annual-report.jsx:45
msgid "Loading…"
msgstr "Kargatzen…"

#: src/components/status.jsx:3333
msgid "HTML Code"
msgstr "HTML kodea"

#: src/components/status.jsx:3350
msgid "HTML code copied"
msgstr "HTML kodea kopiatu da"

#: src/components/status.jsx:3353
msgid "Unable to copy HTML code"
msgstr "Ezin da HTML kodea kopiatu"

#: src/components/status.jsx:3365
msgid "Media attachments:"
msgstr "Multimedia eranskinak:"

#: src/components/status.jsx:3387
msgid "Account Emojis:"
msgstr "Kontuaren emojiak:"

#: src/components/status.jsx:3418
#: src/components/status.jsx:3463
msgid "static URL"
msgstr "URL estatikoa"

#: src/components/status.jsx:3432
msgid "Emojis:"
msgstr "Emojiak:"

#: src/components/status.jsx:3477
msgid "Notes:"
msgstr "Oharrak:"

#: src/components/status.jsx:3481
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "Hau estatikoa da, diseinurik eta scriptik gabekoa. Litekeena da zure estiloak aplikatu eta editatu behar izatea."

#: src/components/status.jsx:3487
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "Bozketak ez dira interaktiboak, zerrendak bilakatzen dira boto-zenbaketan."

#: src/components/status.jsx:3492
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "Multimedia eranskinak irudiak, bideoak, audioak edo edozein fitxategi mota izan daitezke."

#: src/components/status.jsx:3498
msgid "Post could be edited or deleted later."
msgstr "Bidalketa editatu edo ezabatu daiteke geroago."

#: src/components/status.jsx:3504
msgid "Preview"
msgstr "Aurrebista"

#: src/components/status.jsx:3513
msgid "Note: This preview is lightly styled."
msgstr "Oharra: aurrebista honi estilo arin bat aplikatu zaio."

#. [Name] [Visibility icon] boosted
#: src/components/status.jsx:3766
msgid "<0/> <1/> boosted"
msgstr "<0/>(e)k <1/> bultzatu du"

#: src/components/timeline.jsx:479
#: src/pages/settings.jsx:1179
msgid "New posts"
msgstr "Bidalketa berriak"

#: src/components/timeline.jsx:580
#: src/pages/home.jsx:216
#: src/pages/notifications.jsx:890
#: src/pages/status.jsx:1008
#: src/pages/status.jsx:1381
msgid "Try again"
msgstr "Saiatu berriro"

#. placeholder {0}: fItems.length
#: src/components/timeline.jsx:615
msgid "{0, plural, one {# Boost} other {# Boosts}}"
msgstr "{0, plural, one {Bultzada #} other {# bultzada}}"

#: src/components/timeline.jsx:620
msgid "Pinned posts"
msgstr "Finkatutako bidalketak"

#: src/components/timeline.jsx:979
#: src/components/timeline.jsx:986
#: src/pages/catchup.jsx:1898
msgid "Thread"
msgstr "Haria"

#. placeholder {0}: filterInfo.titlesStr
#: src/components/timeline.jsx:1001
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>Iragazita</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:192
msgid "Auto-translated from {sourceLangText}"
msgstr "{sourceLangText} automatikoki itzultzen"

#: src/components/translation-block.jsx:230
msgid "Translating…"
msgstr "Itzultzen…"

#: src/components/translation-block.jsx:233
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "Itzuli {sourceLangText} (automatikoki antzemanda)"

#: src/components/translation-block.jsx:234
msgid "Translate from {sourceLangText}"
msgstr "Itzuli {sourceLangText}"

#. placeholder {0}: detectedLang ?? '…'
#: src/components/translation-block.jsx:262
msgid "Auto ({0})"
msgstr "Automatikoa ({0})"

#: src/components/translation-block.jsx:275
msgid "Failed to translate"
msgstr "Ezin da itzuli"

#: src/compose.jsx:33
msgid "Editing source status"
msgstr "Jatorrizko egoera editatzen"

#. placeholder {0}: replyToStatus.account?.acct || replyToStatus.account?.username
#: src/compose.jsx:35
msgid "Replying to @{0}"
msgstr "@{0}(r)i erantzuten"

#: src/compose.jsx:63
msgid "You may close this page now."
msgstr "Orria itxi dezakezu."

#: src/compose.jsx:71
msgid "Close window"
msgstr "Itxi leihoa"

#: src/compose.jsx:87
msgid "Login required."
msgstr "Saioa hasi behar da."

#: src/compose.jsx:91
#: src/pages/annual-report.jsx:164
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:271
msgid "Go home"
msgstr "Joan orri nagusira"

#: src/pages/account-statuses.jsx:232
msgid "Account posts"
msgstr "Kontuaren bidalketak"

#: src/pages/account-statuses.jsx:239
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ Erantzunak)"

#: src/pages/account-statuses.jsx:241
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- Bultzadak)"

#: src/pages/account-statuses.jsx:243
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:245
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (Multimedia)"

#: src/pages/account-statuses.jsx:251
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:316
msgid "Clear filters"
msgstr "Garbitu iragazkiak"

#: src/pages/account-statuses.jsx:319
msgid "Clear"
msgstr "Garbitu"

#: src/pages/account-statuses.jsx:333
msgid "Showing post with replies"
msgstr "Erantzunak dituzten bidalketak erakusten"

#: src/pages/account-statuses.jsx:338
msgid "+ Replies"
msgstr "+ Erantzunak"

#: src/pages/account-statuses.jsx:344
msgid "Showing posts without boosts"
msgstr "Bultzadarik ez duten bidalketak erakusten"

#: src/pages/account-statuses.jsx:349
msgid "- Boosts"
msgstr "- Bultzadak"

#: src/pages/account-statuses.jsx:355
msgid "Showing posts with media"
msgstr "Multimedia fitxategiak dituzten bidalketak erakusten"

#. placeholder {0}: tag.name
#: src/pages/account-statuses.jsx:372
msgid "Showing posts tagged with #{0}"
msgstr "#{0} traola duten bidalketak erakusten"

#. placeholder {0}: date.toLocaleString(i18n.locale, { month: 'long', year: 'numeric', })
#: src/pages/account-statuses.jsx:411
msgid "Showing posts in {0}"
msgstr ""

#: src/pages/account-statuses.jsx:500
msgid "Nothing to see here yet."
msgstr "Ez dago ikusteko ezer."

#: src/pages/account-statuses.jsx:501
#: src/pages/public.jsx:98
#: src/pages/trending.jsx:447
msgid "Unable to load posts"
msgstr "Ezin dira bidalketak kargatu"

#: src/pages/account-statuses.jsx:542
#: src/pages/account-statuses.jsx:572
msgid "Unable to fetch account info"
msgstr "Ezin da kontuaren informazioa eskuratu"

#. placeholder {0}: accountInstance ? ( <> {' '} (<b>{punycode.toUnicode(accountInstance)}</b>) </> ) : null
#: src/pages/account-statuses.jsx:549
msgid "Switch to account's instance {0}"
msgstr "Aldatu kontuko instantziara {0}"

#: src/pages/account-statuses.jsx:579
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "Aldatu nire instantziara (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:641
msgid "Month"
msgstr "Hilabetea"

#: src/pages/accounts.jsx:56
msgid "Current"
msgstr "Unean"

#: src/pages/accounts.jsx:102
msgid "Default"
msgstr "Lehenetsia"

#: src/pages/accounts.jsx:124
msgid "Switch to this account"
msgstr "Aldatu kontu honetara"

#: src/pages/accounts.jsx:133
msgid "Switch in new tab/window"
msgstr "Aldatu fitxa / leiho berrian"

#: src/pages/accounts.jsx:147
msgid "View profile…"
msgstr "Ikusi profila…"

#: src/pages/accounts.jsx:164
msgid "Set as default"
msgstr "Ezarri lehenetsi gisa"

#. placeholder {0}: account.info.acct
#: src/pages/accounts.jsx:174
msgid "Log out <0>@{0}</0>?"
msgstr "<0>@{0}</0> saioa amaitu nahi?"

#: src/pages/accounts.jsx:197
msgid "Log out…"
msgstr "Amaitu saioa…"

#: src/pages/accounts.jsx:210
msgid "Add an existing account"
msgstr "Gehitu lehendik dudan kontu bat"

#: src/pages/accounts.jsx:217
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "Oharra: <0>Lehenetsitako</0> kontua erabiliko da beti hasieran. Gainerako kontuek saioa irekita mantendu bitartean iraungo dute."

#: src/pages/bookmarks.jsx:26
msgid "No bookmarks yet. Go bookmark something!"
msgstr "Ez duzu laster-markarik. Zoaz gordetzea merezi duen zerbait aurkitzera!"

#: src/pages/bookmarks.jsx:27
msgid "Unable to load bookmarks."
msgstr "Ezin dira laster-markak kargatu."

#: src/pages/catchup.jsx:55
msgid "last 1 hour"
msgstr "azken orduko bidalketak"

#: src/pages/catchup.jsx:56
msgid "last 2 hours"
msgstr "azken 2 ordutako bidalketak"

#: src/pages/catchup.jsx:57
msgid "last 3 hours"
msgstr "azken 3 ordutako bidalketak"

#: src/pages/catchup.jsx:58
msgid "last 4 hours"
msgstr "azken 4 ordutako bidalketak"

#: src/pages/catchup.jsx:59
msgid "last 5 hours"
msgstr "azken 5 ordutako bidalketak"

#: src/pages/catchup.jsx:60
msgid "last 6 hours"
msgstr "azken 6 ordutako bidalketak"

#: src/pages/catchup.jsx:61
msgid "last 7 hours"
msgstr "azken 7 ordutako bidalketak"

#: src/pages/catchup.jsx:62
msgid "last 8 hours"
msgstr "azken 8 ordutako bidalketak"

#: src/pages/catchup.jsx:63
msgid "last 9 hours"
msgstr "azken 9 ordutako bidalketak"

#: src/pages/catchup.jsx:64
msgid "last 10 hours"
msgstr "azken 10 ordutako bidalketak"

#: src/pages/catchup.jsx:65
msgid "last 11 hours"
msgstr "azken 11 ordutako bidalketak"

#: src/pages/catchup.jsx:66
msgid "last 12 hours"
msgstr "azken 12 ordutako bidalketak"

#: src/pages/catchup.jsx:67
msgid "beyond 12 hours"
msgstr "12 ordu baino haratagoko bidalketak"

#: src/pages/catchup.jsx:74
msgid "Followed tags"
msgstr "Jarraitutako traolak"

#: src/pages/catchup.jsx:75
msgid "Groups"
msgstr "Taldeak"

#: src/pages/catchup.jsx:597
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "{selectedFilterCategory, select, all {Bidalketa guztiak} original {Bidalketa originalak} replies {Erantzunak} boosts {Bultzadak} followedTags {Jarraitutako traolak} groups {Taldeak} filtered {Iragazitako bidalketak}} erakusten, {sortBy, select, createdAt {{sortOrder, select, asc {zaharrena} desc {berriena}}} reblogsCount {{sortOrder, select, asc {bultzada gutxien dituena} desc {bultzada gehien dituena}}} favouritesCount {{sortOrder, select, asc {gogoko gutxien dituena} desc {gogoko gehien dituena}}} repliesCount {{sortOrder, select, asc {erantzun gutxien dituena} desc {erantzun gehien dituena}}} density {{sortOrder, select, asc {dentsitate txikiena duena} desc {dentsitate handiena duena}}}}ren arabera sailkatuta lehenengo{groupBy, select, account {, egilearen arabera aldekatuta} other {}}"

#: src/pages/catchup.jsx:888
#: src/pages/catchup.jsx:912
msgid "Catch-up <0>beta</0>"
msgstr "Zer berri? <0>beta</0>"

#: src/pages/catchup.jsx:902
#: src/pages/catchup.jsx:1587
msgid "Help"
msgstr "Laguntza"

#: src/pages/catchup.jsx:918
msgid "What is this?"
msgstr "Zer da hau?"

#: src/pages/catchup.jsx:921
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "Zer berri? denbora-lerro bereizi bat da jarraitzen dituzunekin; goi-mailako ikuspegi bat eskaintzen du begirada batean, posta elektronikoan oinarritutako interfaze erraz batekin, mezuak ordenatzea eta iragaztea ahalbidetzen duena."

#: src/pages/catchup.jsx:932
msgid "Preview of Catch-up UI"
msgstr "Zer berri? interfazearen aurrebista"

#: src/pages/catchup.jsx:941
msgid "Let's catch up"
msgstr "Jar gaitezen egunean"

#: src/pages/catchup.jsx:946
msgid "Let's catch up on the posts from your followings."
msgstr "Jarri egunean jarraitzen diezunen bidalketekin."

#: src/pages/catchup.jsx:950
msgid "Show me all posts from…"
msgstr "Erakutsidazu…"

#: src/pages/catchup.jsx:973
msgid "until the max"
msgstr "gehienez ere"

#: src/pages/catchup.jsx:1003
msgid "Catch up"
msgstr "Jarri egunean"

#: src/pages/catchup.jsx:1009
msgid "Overlaps with your last catch-up"
msgstr "Azken eguneraketarekin gainjartzen da"

#. placeholder {0}: dtf.format(new Date(lastCatchupEndAt))
#: src/pages/catchup.jsx:1021
msgid "Until the last catch-up ({0})"
msgstr "Azken eguneraketara arte ({0})"

#: src/pages/catchup.jsx:1030
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Oharra: litekeena da instantziak gehienez (gutxi gorabehera) 800 bidalketa erakustea hasierako denbora-lerroan, denbora tartea izaten dena izaten dela."

#: src/pages/catchup.jsx:1040
msgid "Previously…"
msgstr "Lehenago…"

#. placeholder {0}: pc.count
#: src/pages/catchup.jsx:1058
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {bidalketa #} other {# bidalketa}}"

#: src/pages/catchup.jsx:1068
msgid "Remove this catch-up?"
msgstr "Eguneraketa kendu?"

#. placeholder {0}: pc.id
#: src/pages/catchup.jsx:1071
msgid "Removing Catch-up {0}"
msgstr "{0} eguneraketa kentzen"

#. placeholder {0}: pc.id
#: src/pages/catchup.jsx:1075
msgid "Catch-up {0} removed"
msgstr ""

#: src/pages/catchup.jsx:1089
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Oharra: gehienez 3 gordeko dira. Gainerakoak automatikoki kenduko dira."

#: src/pages/catchup.jsx:1104
msgid "Fetching posts…"
msgstr "Bidalketak eskuratzen…"

#: src/pages/catchup.jsx:1107
msgid "This might take a while."
msgstr "Litekeena da donbora behar izatea."

#: src/pages/catchup.jsx:1142
msgid "Reset filters"
msgstr "Berrezarri iragazkiak"

#: src/pages/catchup.jsx:1150
#: src/pages/catchup.jsx:1593
msgid "Top links"
msgstr "Gori-gorian dauden estekak"

#. placeholder {0}: sharers.map((s) => { const { avatarStatic, displayName } = s; return ( <button type="button" class="plain" style={{ padding: 0, }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); // Reset and filter to author const { id } = s; setSelectedAuthor(id); setSelectedFilterCategory('all'); }} > <Avatar url={avatarStatic} size="s" alt={displayName} /> </button> ); })
#: src/pages/catchup.jsx:1263
msgid "Shared by {0}"
msgstr "{0}(e)k partekatua"

#: src/pages/catchup.jsx:1318
#: src/pages/mentions.jsx:148
#: src/pages/search.jsx:326
msgid "All"
msgstr "Guztia"

#. placeholder {0}: authorCountsList.length
#: src/pages/catchup.jsx:1403
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural, one {egile #} other {# egile}}"

#: src/pages/catchup.jsx:1415
msgid "Sort"
msgstr "Sailkatu"

#: src/pages/catchup.jsx:1446
msgid "Date"
msgstr "Data"

#: src/pages/catchup.jsx:1450
msgid "Density"
msgstr "Dentsitatea"

#. js-lingui-explicit-id
#: src/pages/catchup.jsx:1473
msgid "group.filter"
msgstr "Iragazi"

#: src/pages/catchup.jsx:1488
msgid "Authors"
msgstr "Egileak"

#: src/pages/catchup.jsx:1489
msgid "None"
msgstr "Bat ere ez"

#: src/pages/catchup.jsx:1505
msgid "Show all authors"
msgstr "Erakutsi egile guztiak"

#: src/pages/catchup.jsx:1556
msgid "You don't have to read everything."
msgstr "Ez duzu zertan guztia irakurri."

#: src/pages/catchup.jsx:1557
msgid "That's all."
msgstr "Hori da guztia."

#: src/pages/catchup.jsx:1565
msgid "Back to top"
msgstr "Itzuli gora"

#: src/pages/catchup.jsx:1596
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Jarraitzen dituzunek partekatutako estekak, partekatutako, bultzatutako eta gogoko egindako zenbakiagatik sailkatuta."

#: src/pages/catchup.jsx:1602
msgid "Sort: Density"
msgstr "Sailkatu: dentsitatea"

#: src/pages/catchup.jsx:1605
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "Bidalketak informazioaren dentsitatearen edo sakoneraren arabera sailkatzen dira. Postu motzenak \"arinagoak\" dira, eta luzeenak, berriz, \"astunagoak\". Argazkidun bidalketak argazkirik gabekoak baino \"astunagoak\" dira."

#: src/pages/catchup.jsx:1612
msgid "Group: Authors"
msgstr "Taldekatu: egileak"

#: src/pages/catchup.jsx:1615
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "Bidalketak egilearen arabera taldekatzen dira, egilearen bidalketen kopuruaren arabera sailkatuta."

#: src/pages/catchup.jsx:1662
msgid "Next author"
msgstr "Hurrengo egilea"

#: src/pages/catchup.jsx:1670
msgid "Previous author"
msgstr "Aurreko egilea"

#: src/pages/catchup.jsx:1686
msgid "Scroll to top"
msgstr "Korritu gora"

#: src/pages/favourites.jsx:26
msgid "No likes yet. Go like something!"
msgstr "Ez dugu gogokorik. Zoaz gogoko zerbait aurkitzera!"

#: src/pages/favourites.jsx:27
msgid "Unable to load likes."
msgstr "Ezin dira gogokoak kargatu."

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "Hasiera eta zerrendak"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr "Denbora-lerro publikoak"

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "Elkarrizketak"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "Profilak"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr "Inoiz ez"

#: src/pages/filters.jsx:104
#: src/pages/filters.jsx:229
msgid "New filter"
msgstr "Iragazki berria"

#. placeholder {0}: filters.length
#: src/pages/filters.jsx:152
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural, one {Iragazki #} other {# iragazki}}"

#: src/pages/filters.jsx:167
msgid "Unable to load filters."
msgstr "Ezin dira iragazkiak kargatu."

#: src/pages/filters.jsx:171
msgid "No filters yet."
msgstr "Oraindik ez dago iragazkirik."

#: src/pages/filters.jsx:178
msgid "Add filter"
msgstr "Gehitu iragazkia"

#: src/pages/filters.jsx:229
msgid "Edit filter"
msgstr "Editatu iragazkia"

#: src/pages/filters.jsx:346
msgid "Unable to edit filter"
msgstr "Ezin da iragazkia editatu"

#: src/pages/filters.jsx:347
msgid "Unable to create filter"
msgstr "Ezin da iragazkia sortu"

#: src/pages/filters.jsx:356
msgid "Title"
msgstr "Izenburua"

#: src/pages/filters.jsx:397
msgid "Whole word"
msgstr "Hitz osoa"

#: src/pages/filters.jsx:423
msgid "No keywords. Add one."
msgstr "Ez dago hitz-gakorik."

#: src/pages/filters.jsx:450
msgid "Add keyword"
msgstr "Gehitu hitz-gakoa"

#. placeholder {0}: filteredEditKeywords.length
#: src/pages/filters.jsx:454
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {hitz-gako #} other {# hitz-gako}}"

#: src/pages/filters.jsx:467
msgid "Filter from…"
msgstr "Iragazi…"

#: src/pages/filters.jsx:493
msgid "* Not implemented yet"
msgstr "* Inplementatzeke"

#: src/pages/filters.jsx:499
msgid "Status: <0><1/></0>"
msgstr "Egoera: <0><1/></0>"

#: src/pages/filters.jsx:508
msgid "Change expiry"
msgstr "Aldatu iraungitzea"

#: src/pages/filters.jsx:508
msgid "Expiry"
msgstr "Iraungitzea"

#: src/pages/filters.jsx:527
msgid "Filtered post will be…"
msgstr "Iragazitako bidalketak…"

#: src/pages/filters.jsx:538
msgid "obscured (media only)"
msgstr ""

#: src/pages/filters.jsx:552
msgid "minimized"
msgstr "txikituko dira"

#: src/pages/filters.jsx:562
msgid "hidden"
msgstr "ezkutatuko dira"

#: src/pages/filters.jsx:579
msgid "Delete this filter?"
msgstr "Iragazkia ezabatu nahi duzu?"

#: src/pages/filters.jsx:592
msgid "Unable to delete filter."
msgstr "Ezin da iragazkia ezabatu."

#: src/pages/filters.jsx:625
msgid "Expired"
msgstr "Iraungi da"

#: src/pages/filters.jsx:627
msgid "Expiring <0/>"
msgstr "<0/>(e)an iraungiko da"

#: src/pages/filters.jsx:631
msgid "Never expires"
msgstr "Ez da inoiz iraungiko"

#. placeholder {0}: followedHashtags.length
#: src/pages/followed-hashtags.jsx:71
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {traola #} other {# traola}}"

#: src/pages/followed-hashtags.jsx:86
msgid "Unable to load followed hashtags."
msgstr "Ezin dira jarraitutako traolak kargatu."

#: src/pages/followed-hashtags.jsx:90
msgid "No hashtags followed yet."
msgstr "Oraindik ez duzu traolarik jarraitzen."

#: src/pages/following.jsx:144
msgid "Nothing to see here."
msgstr "Ez dago ikusteko ezer."

#: src/pages/following.jsx:145
#: src/pages/list.jsx:109
msgid "Unable to load posts."
msgstr "Ezin dira bidalketak kargatu."

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (multimedia fitxategiak bakarrik) {instance}(e)n"

#: src/pages/hashtag.jsx:57
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} {instance}(e)n"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (multimedia fitxategiak bakarrik)"

#: src/pages/hashtag.jsx:60
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:182
msgid "No one has posted anything with this tag yet."
msgstr "Oraindik ez du inork traola hau erabili."

#: src/pages/hashtag.jsx:183
msgid "Unable to load posts with this tag"
msgstr "Ezin dira etiketa hau duten bidalketak kargatu"

#: src/pages/hashtag.jsx:209
msgid "Unfollow #{hashtag}?"
msgstr "#{hashtag} jarraitzeari utzi?"

#: src/pages/hashtag.jsx:224
msgid "Unfollowed #{hashtag}"
msgstr "#{hashtag} jarraitzeari utzi diozu"

#: src/pages/hashtag.jsx:239
msgid "Followed #{hashtag}"
msgstr "#{hashtag} jarraitzen ari zara"

#: src/pages/hashtag.jsx:255
msgid "Following…"
msgstr "Jarraitzen…"

#: src/pages/hashtag.jsx:283
msgid "Unfeatured on profile"
msgstr "Utzi profilean nabarmentzeari"

#: src/pages/hashtag.jsx:297
msgid "Unable to unfeature on profile"
msgstr "Ezin da profilean nabarmentzen uzteari utzi"

#: src/pages/hashtag.jsx:306
#: src/pages/hashtag.jsx:322
msgid "Featured on profile"
msgstr "Profilean nabarmentzen"

#: src/pages/hashtag.jsx:329
msgid "Feature on profile"
msgstr "Nabarmendu profilean"

#: src/pages/hashtag.jsx:394
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, one {}other {Gehienez # traola}}"

#: src/pages/hashtag.jsx:397
msgid "Add hashtag"
msgstr "Gehitu traola"

#: src/pages/hashtag.jsx:429
msgid "Remove hashtag"
msgstr "Kendu traola"

#: src/pages/hashtag.jsx:443
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr "{SHORTCUTS_LIMIT, plural, one {Gehienezko lasterbidera (#) iritsi zara. Ezin da lasterbidea gehitu.} other {Gehienezko # lasterbideetara iritsi zara. Ezin da lasterbidea gehitu.}}"

#: src/pages/hashtag.jsx:472
msgid "This shortcut already exists"
msgstr "Lasterbidea badago lehendik ere"

#: src/pages/hashtag.jsx:475
msgid "Hashtag shortcut added"
msgstr "Traolaren lasterbidea gehitu da"

#: src/pages/hashtag.jsx:481
msgid "Add to Shortcuts"
msgstr "Gehitu lasterbideetara"

#: src/pages/hashtag.jsx:487
#: src/pages/public.jsx:140
#: src/pages/trending.jsx:476
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "Sartu instantzia berria, adib. \"mastodon.eus\""

#: src/pages/hashtag.jsx:490
#: src/pages/public.jsx:143
#: src/pages/trending.jsx:479
msgid "Invalid instance"
msgstr "Instantzia baliogabea"

#: src/pages/hashtag.jsx:504
#: src/pages/public.jsx:157
#: src/pages/trending.jsx:491
msgid "Go to another instance…"
msgstr "Joan beste instantzia batera…"

#: src/pages/hashtag.jsx:517
#: src/pages/public.jsx:170
#: src/pages/trending.jsx:502
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "Joan nire instantziara (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:212
msgid "Unable to fetch notifications."
msgstr "Ezin dira jakinarazpenak eskuratu."

#: src/pages/home.jsx:233
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<1>Jarraipen-eskaera</1> <0>berria</0>"

#: src/pages/home.jsx:239
msgid "See all"
msgstr "Ikusi guztia"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr "Ebazten…"

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr "Ezin da URLa ebatzi"

#: src/pages/list.jsx:108
msgid "Nothing yet."
msgstr "Oraindik ezer ez."

#: src/pages/list.jsx:177
#: src/pages/list.jsx:281
msgid "Manage members"
msgstr "Kudeatu kideak"

#. placeholder {0}: account.username
#: src/pages/list.jsx:316
msgid "Remove <0>@{0}</0> from list?"
msgstr "<0>@{0}</0> zerrendatik kendu nahi?"

#: src/pages/list.jsx:362
msgid "Remove…"
msgstr "Kendu…"

#. placeholder {0}: lists.length
#: src/pages/lists.jsx:94
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {zerrenda #} other {zerrenda #}}"

#: src/pages/lists.jsx:109
msgid "No lists yet."
msgstr "Oraindik ez dago zerrendarik."

#: src/pages/login.jsx:110
#: src/pages/login.jsx:123
msgid "Failed to register application"
msgstr "Aplikazioa erregistratzeak huts egin du"

#: src/pages/login.jsx:209
msgid "instance domain"
msgstr "instantziaren domeinua"

#: src/pages/login.jsx:233
msgid "e.g. “mastodon.social”"
msgstr "adib. \"mastodon.eus\""

#: src/pages/login.jsx:244
msgid "Failed to log in. Please try again or try another instance."
msgstr "Ezin da saioa hasi. Saiatu berriro edo saiatu beste instantzia batean."

#: src/pages/login.jsx:256
msgid "Continue with {selectedInstanceText}"
msgstr "Jarraitu {selectedInstanceText}(r)ekin"

#: src/pages/login.jsx:257
msgid "Continue"
msgstr "Jarraitu"

#: src/pages/login.jsx:265
msgid "Don't have an account? Create one!"
msgstr "Oraindik ez duzu konturik? Sortu ezazu!"

#: src/pages/mentions.jsx:21
msgid "Private mentions"
msgstr "Aipamen pribatuak"

#: src/pages/mentions.jsx:160
msgid "Private"
msgstr "Pribatua"

#: src/pages/mentions.jsx:170
msgid "No one mentioned you :("
msgstr "Ez zaitu inork aipatu :("

#: src/pages/mentions.jsx:171
msgid "Unable to load mentions."
msgstr "Ezin dira aipamenak kargatu."

#: src/pages/notifications.jsx:105
msgid "You don't follow"
msgstr "Jarraitzen ez ditudanenak"

#: src/pages/notifications.jsx:106
msgid "Who don't follow you"
msgstr "Jarraitzen ez nautenenak"

#: src/pages/notifications.jsx:107
msgid "With a new account"
msgstr "Kontu berria dutenenak"

#: src/pages/notifications.jsx:108
msgid "Who unsolicitedly private mention you"
msgstr "Nik nahi gabe era pribatuan aipatu nautenenak"

#: src/pages/notifications.jsx:109
msgid "Who are limited by server moderators"
msgstr "Zerbitzariko moderatzaileek muga jarri dietenak"

#: src/pages/notifications.jsx:597
#: src/pages/notifications.jsx:938
msgid "Notifications settings"
msgstr "Jakinarazpenen ezarpenak"

#: src/pages/notifications.jsx:615
msgid "New notifications"
msgstr "Jakinarazpen berriak"

#. placeholder {0}: announcements.length
#: src/pages/notifications.jsx:626
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr "{0, plural, one {Iragarpena} other {Iragarpenak}}"

#: src/pages/notifications.jsx:673
#: src/pages/settings.jsx:1167
msgid "Follow requests"
msgstr "Jarraipen-eskaerak"

#. placeholder {0}: followRequests.length
#: src/pages/notifications.jsx:678
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {Jarraipen-eskaera #} other {# jarraipen-eskaera}}"

#. placeholder {0}: notificationsPolicy.summary.pendingRequestsCount
#: src/pages/notifications.jsx:733
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr "{0, plural, one {Pertsona #en iragazitako jakinarazpenak} other {# pertsonaren iragazitako jakinarazpenak}}"

#: src/pages/notifications.jsx:806
msgid "Only mentions"
msgstr "Aipamenak soilik"

#: src/pages/notifications.jsx:810
msgid "Today"
msgstr "Gaur"

#: src/pages/notifications.jsx:815
msgid "You're all caught up."
msgstr "Zaharrak berri."

#: src/pages/notifications.jsx:838
msgid "Yesterday"
msgstr "Atzo"

#: src/pages/notifications.jsx:886
msgid "Unable to load notifications"
msgstr "Ezin dira jakinarazpenak kargatu"

#: src/pages/notifications.jsx:965
msgid "Notifications settings updated"
msgstr "Jakinarazpenen ezarpenak eguneratu dira"

#: src/pages/notifications.jsx:973
msgid "Filter out notifications from people:"
msgstr "Ez erakutsi hauen jakinarazpenak:"

#: src/pages/notifications.jsx:987
msgid "Filter"
msgstr "Iragazi"

#: src/pages/notifications.jsx:990
msgid "Ignore"
msgstr "Ez hartu kontuan"

#. placeholder {0}: niceDateTime(updatedAtDate)
#: src/pages/notifications.jsx:1063
msgid "Updated <0>{0}</0>"
msgstr "<0>{0}</0>(e)an eguneratu zen"

#. placeholder {0}: account.username
#: src/pages/notifications.jsx:1131
msgid "View notifications from <0>@{0}</0>"
msgstr "Ikusi <0>@{0}</0>(r)en jakinarazpenak"

#. placeholder {0}: account.username
#: src/pages/notifications.jsx:1152
msgid "Notifications from <0>@{0}</0>"
msgstr "<0>@{0}</0>(r)en jakinarazpenak"

#. placeholder {0}: request.account.username
#: src/pages/notifications.jsx:1220
msgid "Notifications from @{0} will not be filtered from now on."
msgstr "Aurrerantzean ez dira @{0}(r)en jakinarazpenak iragaziko."

#: src/pages/notifications.jsx:1225
msgid "Unable to accept notification request"
msgstr "Ezin da jakinarazpen-eskaera onartu"

#: src/pages/notifications.jsx:1230
msgid "Allow"
msgstr "Baimendu"

#. placeholder {0}: request.account.username
#: src/pages/notifications.jsx:1250
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr ""

#: src/pages/notifications.jsx:1255
msgid "Unable to dismiss notification request"
msgstr "Ezin da jakinarazpen-eskaera zokoratu"

#: src/pages/notifications.jsx:1260
msgid "Dismiss"
msgstr "Baztertu"

#: src/pages/notifications.jsx:1275
msgid "Dismissed"
msgstr "Baztertuta"

#: src/pages/public.jsx:28
msgid "Local timeline ({instance})"
msgstr "Denbora-lerro lokala ({instance})"

#: src/pages/public.jsx:29
msgid "Federated timeline ({instance})"
msgstr "Denbora-lerro federatua ({instance})"

#: src/pages/public.jsx:91
msgid "Local timeline"
msgstr "Denbora-lerro lokala"

#: src/pages/public.jsx:91
msgid "Federated timeline"
msgstr "Denbora-lerro federatua"

#: src/pages/public.jsx:97
msgid "No one has posted anything yet."
msgstr "Oraindik inork ez du ezer argitaratu."

#: src/pages/public.jsx:124
msgid "Switch to Federated"
msgstr "Aldatu federatura"

#: src/pages/public.jsx:131
msgid "Switch to Local"
msgstr "Aldatu lokalera"

#: src/pages/scheduled-posts.jsx:108
msgid "No scheduled posts."
msgstr "Ez dago programatutako bidalketarik."

#. Scheduled [in 1 day] ([Thu, Feb 27, 6:30:00 PM])
#. placeholder {0}: niceDateTime(scheduledAt, { formatOpts: { weekday: 'short', second: 'numeric', }, })
#: src/pages/scheduled-posts.jsx:205
msgid "Scheduled <0><1/></0> <2>({0})</2>"
msgstr "Programatuta <0><1/></0> <2>({0})</2>"

#. Scheduled [in 1 day]
#: src/pages/scheduled-posts.jsx:261
msgid "Scheduled <0><1/></0>"
msgstr "Programatuta <0><1/></0>"

#: src/pages/scheduled-posts.jsx:306
msgid "Scheduled post rescheduled"
msgstr "Programatutako bidalketa berriro programatu da"

#: src/pages/scheduled-posts.jsx:313
msgid "Failed to reschedule post"
msgstr "Huts egin du bidalketa programatzeak"

#: src/pages/scheduled-posts.jsx:336
msgid "Reschedule"
msgstr "Programatu berriro"

#: src/pages/scheduled-posts.jsx:342
msgid "Delete scheduled post?"
msgstr "Ezabatu programatutako bidalketa?"

#: src/pages/scheduled-posts.jsx:350
msgid "Scheduled post deleted"
msgstr "Programatutako bidalketa ezabatu da"

#: src/pages/scheduled-posts.jsx:357
msgid "Failed to delete scheduled post"
msgstr "Huts egin du programatutako bidalketa ezabatzeak"

#: src/pages/search.jsx:50
msgid "Search: {q} (Posts)"
msgstr "Bilatu: {q} (Bidalketak)"

#: src/pages/search.jsx:53
msgid "Search: {q} (Accounts)"
msgstr "Bilatu: {q} (Kontuak)"

#: src/pages/search.jsx:56
msgid "Search: {q} (Hashtags)"
msgstr "Bilatu: {q} (Traolak)"

#: src/pages/search.jsx:59
msgid "Search: {q}"
msgstr "Bilatu: {q}"

#: src/pages/search.jsx:336
#: src/pages/search.jsx:418
msgid "Hashtags"
msgstr "Traolak"

#: src/pages/search.jsx:368
#: src/pages/search.jsx:422
#: src/pages/search.jsx:492
msgid "See more"
msgstr "Ikusi gehiago"

#: src/pages/search.jsx:394
msgid "See more accounts"
msgstr "Ikusi kontu gehiago"

#: src/pages/search.jsx:408
msgid "No accounts found."
msgstr "Ez da konturik aurkitu."

#: src/pages/search.jsx:464
msgid "See more hashtags"
msgstr "Ikusi traola gehiago"

#: src/pages/search.jsx:478
msgid "No hashtags found."
msgstr "Ez da traolarik aurkitu."

#: src/pages/search.jsx:522
msgid "See more posts"
msgstr "Ikusi bidalketa gehiago"

#: src/pages/search.jsx:536
msgid "No posts found."
msgstr "Ez da bidalketarik aurkitu."

#: src/pages/search.jsx:580
msgid "Enter your search term or paste a URL above to get started."
msgstr "Sartu bilatzeko terminoa edo itsatsi URLa gainean."

#: src/pages/settings.jsx:92
msgid "Settings"
msgstr "Ezarpenak"

#: src/pages/settings.jsx:101
msgid "Appearance"
msgstr "Itxura"

#: src/pages/settings.jsx:177
msgid "Light"
msgstr "Argia"

#: src/pages/settings.jsx:188
msgid "Dark"
msgstr "Iluna"

#: src/pages/settings.jsx:201
msgid "Auto"
msgstr "Automatikoa"

#: src/pages/settings.jsx:211
msgid "Text size"
msgstr "Testuaren tamaina"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:216
#: src/pages/settings.jsx:241
msgid "A"
msgstr "A"

#: src/pages/settings.jsx:255
msgid "Display language"
msgstr "Pantaila-hizkuntza"

#: src/pages/settings.jsx:264
msgid "Volunteer translations"
msgstr "Eskaini burua itzultzeko"

#: src/pages/settings.jsx:275
msgid "Posting"
msgstr "Argitaratzean"

#: src/pages/settings.jsx:282
msgid "Default visibility"
msgstr "Ikusgaitasuna, defektuz"

#: src/pages/settings.jsx:283
#: src/pages/settings.jsx:329
msgid "Synced"
msgstr "Sinkronizatuta"

#: src/pages/settings.jsx:308
msgid "Failed to update posting privacy"
msgstr "Ezin da bidalketaren pribatutasuna eguneratu"

#: src/pages/settings.jsx:331
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "Zure zerbitzariko ezarpenekin sinkronizatu da. <0>Joan zure instantziara ({instance}) ezarpen gehiagorako.</0>"

#: src/pages/settings.jsx:346
msgid "Experiments"
msgstr "Esperimentuak"

#: src/pages/settings.jsx:359
msgid "Auto refresh timeline posts"
msgstr "Automatikoki freskatu denbora-lerroko bidalketak"

#: src/pages/settings.jsx:371
msgid "Boosts carousel"
msgstr "Bultzaden karrusela"

#: src/pages/settings.jsx:388
msgid "Post translation"
msgstr "Bidalketen itzulpena"

#: src/pages/settings.jsx:399
msgid "Translate to "
msgstr "Itzuli… "

#: src/pages/settings.jsx:410
msgid "System language ({systemTargetLanguageText})"
msgstr "Sistemak darabilena ({systemTargetLanguageText})"

#. placeholder {0}: snapStates.settings.contentTranslationHideLanguages .length
#: src/pages/settings.jsx:436
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural, one {}=0 {Ezkutatu \"Itzuli\" botoia honentzat:} other {Ezkutatu \"Itzuli\" botoia (#) hauentzat:}}"

#: src/pages/settings.jsx:491
msgid "Note: This feature uses external translation services, powered by <0>{TRANSLATION_API_NAME}</0>."
msgstr ""

#: src/pages/settings.jsx:519
msgid "Auto inline translation"
msgstr "Itzulpen automatikoa bidalketan bertan"

#: src/pages/settings.jsx:523
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr "Erakutsi automatikoki bidalketen itzulpena denbora-lerroaren baitan. Bidalketa <0>labur</0>retarako balio du bakarrik, eta ezin dute edukiari buruzko oharrik, multimedia fitxategirik edo bozketarik izan."

#: src/pages/settings.jsx:544
msgid "GIF Picker for composer"
msgstr "GIF hautatzailea"

#: src/pages/settings.jsx:548
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr "Oharra: ezaugarri honek hirugarrenen zerbitzua darabil GIFen bilaketarako, <0>GIPHY</0>k eskainia. Adin guztietarako egokia da, jarraipen parametroak ezabatu egiten dira, jatorriaren informazioa eskarietatik kanpo uzten da, baina bilaketa-kontsultek eta IP helbidearen informazioak bere zerbitzarietara iristen jarraituko dute."

#: src/pages/settings.jsx:577
msgid "Image description generator"
msgstr "Irudien deskribapen-sortzailea"

#: src/pages/settings.jsx:582
msgid "Only for new images while composing new posts."
msgstr "Soilik irudi berrientzat bidalketa berriak idaztean."

#: src/pages/settings.jsx:589
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "Oharra: ezaugarri honek hirugarrenen AA zerbitzua darabil, <0>img-alt-api</0>k eskainia. Litekeena da erabat ondo ez egitea. Soilik irudientzat eta soilik ingelesez."

#: src/pages/settings.jsx:617
msgid "Server-side grouped notifications"
msgstr "Zerbitzariak taldekatutako jakinarazpenak"

#: src/pages/settings.jsx:621
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr "Alpha fasean dagoen ezaugarria. Taldekatzea hobetu lezake, baina oinarrizko logika erabiliz."

#: src/pages/settings.jsx:642
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr "Lasterbideen hodeiko inportazio / esportazio ezarpenak"

#: src/pages/settings.jsx:647
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr "⚠️⚠️⚠️ Oso esperimentala.<0/>Zure profileko oharretan gordetzen da. Profileko oharrak (pribatuak) beste profil batzuei buruzko oharretarako erabiltzen dira nagusiki, eta norberaren profilean ezkutatuta daude."

#: src/pages/settings.jsx:658
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr "Oharra: ezaugarri honek saio hasita duzun zerbitzariaren APIa darabil."

#: src/pages/settings.jsx:675
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr "Eskalki modua <0>(<1>Testua</1> → <2>████</2>)</0>"

#: src/pages/settings.jsx:684
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr "Testua blokeekin ordezkatzen du, pantaila-argazkiak egitean aproposa pribatutasun arrazoiengatik."

#: src/pages/settings.jsx:709
msgid "About"
msgstr "Honi buruz"

#: src/pages/settings.jsx:748
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr "<1>@cheeaun</1>ek <0>sortua</0>"

#: src/pages/settings.jsx:777
msgid "Sponsor"
msgstr "Eman babesa"

#: src/pages/settings.jsx:785
msgid "Donate"
msgstr "Egin dohaintza"

#: src/pages/settings.jsx:797
msgid "Privacy Policy"
msgstr "Pribatutasun politika"

#. placeholder {0}: WEBSITE.replace(/https?:\/\//g, '').replace(/\/$/, '')
#: src/pages/settings.jsx:804
msgid "<0>Site:</0> {0}"
msgstr "<0>Gunea:</0> {0}"

#. placeholder {0}: !__FAKE_COMMIT_HASH__ && ( <span class="ib insignificant"> ( <a href={`https://github.com/cheeaun/phanpy/commit/${__COMMIT_HASH__}`} target="_blank" rel="noopener" > <RelativeTime datetime={new Date(__BUILD_TIME__)} /> </a> ) </span> )
#: src/pages/settings.jsx:811
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Bertsioa:</0> <1/> {0}"

#: src/pages/settings.jsx:826
msgid "Version string copied"
msgstr "Bertsioaren haria kopiatuta"

#: src/pages/settings.jsx:829
msgid "Unable to copy version string"
msgstr "Ezin da bertsioaren haria kopiatu"

#: src/pages/settings.jsx:1064
#: src/pages/settings.jsx:1069
msgid "Failed to update subscription. Please try again."
msgstr "Ezin da harpidetza eguneratu. Saiatu berriro."

#: src/pages/settings.jsx:1075
msgid "Failed to remove subscription. Please try again."
msgstr "Ezin da harpidetza kendu. Saiatu berriro."

#: src/pages/settings.jsx:1082
msgid "Push Notifications (beta)"
msgstr "Push jakinarazpenak (beta)"

#: src/pages/settings.jsx:1104
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr "Push jakinarazpenak blokeatuta daude. Gaitu itzazu nabigatzaileko ezarpenetan."

#. placeholder {0}: [ { value: 'all', label: t`anyone`, }, { value: 'followed', label: t`people I follow`, }, { value: 'follower', label: t`followers`, }, ].map((type) => ( <option value={type.value}>{type.label}</option> ))
#: src/pages/settings.jsx:1113
msgid "Allow from <0>{0}</0>"
msgstr "Baimendu <0>{0}</0>(r)en"

#: src/pages/settings.jsx:1122
msgid "anyone"
msgstr "edonor"

#: src/pages/settings.jsx:1126
msgid "people I follow"
msgstr "jarraitzen diodan jendea"

#: src/pages/settings.jsx:1130
msgid "followers"
msgstr "jarraitzaile"

#: src/pages/settings.jsx:1163
msgid "Follows"
msgstr "Jarraitzen die"

#: src/pages/settings.jsx:1171
msgid "Polls"
msgstr "Bozketak"

#: src/pages/settings.jsx:1175
msgid "Post edits"
msgstr "Bidalketen edizioak"

#: src/pages/settings.jsx:1196
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr "Ez da push baimenik eman saioa azkenekoz hasi zenuenetik. <0><1>Hasi saioa</1> berriro baimentzeko</0>."

#: src/pages/settings.jsx:1212
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "Oharra: push jakinarazpenak <0>kontu bakarrarentzat</0> dabiltza."

#. js-lingui-explicit-id
#: src/pages/status.jsx:599
#: src/pages/status.jsx:1151
msgid "post.title"
msgstr "Bidalketa"

#: src/pages/status.jsx:842
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr "Ez duzu saiorik hasi. Ezin duzu interaktuatu (erantzun, bultzatu...)"

#: src/pages/status.jsx:862
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr "Bidalketa hau beste instantzia batekoa da (<0>{instance}</0>). Interakzioak (erantzunak, bultzadak, etab.) ez dira posible."

#: src/pages/status.jsx:890
msgid "Error: {e}"
msgstr "Errorea: {e}"

#: src/pages/status.jsx:897
msgid "Switch to my instance to enable interactions"
msgstr "Aldatu nire instantziara interakzioak gaitzeko"

#: src/pages/status.jsx:999
msgid "Unable to load replies."
msgstr "Ezin dira erantzunak kargatu."

#: src/pages/status.jsx:1111
msgid "Back"
msgstr "Atzera"

#: src/pages/status.jsx:1142
msgid "Go to main post"
msgstr "Joan bidalketa nagusira"

#. placeholder {0}: ancestors.length
#: src/pages/status.jsx:1165
msgid "{0} posts above ‒ Go to top"
msgstr "{0} bidalketa goian ‒ Joan gora"

#: src/pages/status.jsx:1208
#: src/pages/status.jsx:1271
msgid "Switch to Side Peek view"
msgstr "Aldatu gainbegirada bistara"

#: src/pages/status.jsx:1272
msgid "Switch to Full view"
msgstr "Aldatu bista osora"

#: src/pages/status.jsx:1290
msgid "Show all sensitive content"
msgstr "Erakutsi eduki hunkigarri guztia"

#: src/pages/status.jsx:1295
msgid "Experimental"
msgstr "Esperimentala"

#: src/pages/status.jsx:1304
msgid "Unable to switch"
msgstr "Ezin da aldatu"

#. placeholder {0}: punycode.toUnicode( postInstance, )
#: src/pages/status.jsx:1311
msgid "Switch to post's instance ({0})"
msgstr ""

#: src/pages/status.jsx:1314
msgid "Switch to post's instance"
msgstr "Aldatu bidalketaren instantziara"

#: src/pages/status.jsx:1372
msgid "Unable to load post"
msgstr "Ezin da bidalketa kargatu"

#. placeholder {0}: replies.length
#. placeholder {1}: shortenNumber(replies.length)
#: src/pages/status.jsx:1508
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr "{0, plural, one {erantzun #} other {<0>{1}</0> erantzun}}"

#. placeholder {0}: shortenNumber(totalComments)
#: src/pages/status.jsx:1526
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr "{totalComments, plural, one {iruzkin #} other {<0>{0}</0> iruzkin}}"

#: src/pages/status.jsx:1548
msgid "View post with its replies"
msgstr "Ikusi bidalketa eta erantzunak"

#: src/pages/trending.jsx:73
msgid "Trending ({instance})"
msgstr "Joerak ({instance})"

#: src/pages/trending.jsx:230
msgid "Trending News"
msgstr "Pil-pilean dauden albisteak"

#. By [Author]
#. placeholder {0}: author ? ( <NameText account={author} showAvatar /> ) : authorUrl ? ( <a href={authorUrl} target="_blank" rel="noopener" > {authorName} </a> ) : ( authorName )
#: src/pages/trending.jsx:345
msgid "By {0}"
msgstr "{0}(r)en eskutik"

#: src/pages/trending.jsx:406
msgid "Back to showing trending posts"
msgstr "Itzuli bogan dauden bidalketetara"

#. placeholder {0}: currentLink .replace(/^https?:\/\/(www\.)?/i, '') .replace(/\/$/, '')
#: src/pages/trending.jsx:411
msgid "Showing posts mentioning <0>{0}</0>"
msgstr "<0>{0}</0> aipatzen duten bidalketak erakusten"

#: src/pages/trending.jsx:423
msgid "Trending posts"
msgstr "Bogan dauden bidalketak"

#: src/pages/trending.jsx:446
msgid "No trending posts."
msgstr "Ez dago bogadn dagoen joerarik."

#: src/pages/welcome.jsx:54
msgid "A minimalistic opinionated Mastodon web client."
msgstr "Mastodon erabiltzeko web-bezero minimalista eta aparta."

#: src/pages/welcome.jsx:65
msgid "Log in with Mastodon"
msgstr "Hasi saioa Mastodon-ekin"

#: src/pages/welcome.jsx:71
msgid "Sign up"
msgstr "Eman izena"

#: src/pages/welcome.jsx:78
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr "Konektatu zure Mastodon / Fedibertsoko kontua.<0/>Zure egiaztagiriak ez dira zerbitzari honetan gordetzen."

#: src/pages/welcome.jsx:95
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr "<1>@cheeaun</1>ek <0>sortua</0>. <2>Pribatutasun politika</2>."

#: src/pages/welcome.jsx:126
msgid "Screenshot of Boosts Carousel"
msgstr "Bultzaden karruselaren pantaila-argazkia"

#: src/pages/welcome.jsx:130
msgid "Boosts Carousel"
msgstr "Bultzaden karrusela"

#: src/pages/welcome.jsx:133
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr "Bereizi bisualki bidalketa originalak eta partekatutakoak (bultzadak)."

#: src/pages/welcome.jsx:142
msgid "Screenshot of nested comments thread"
msgstr "Habiratutako iruzkinen hariaren pantaila-argazkia"

#: src/pages/welcome.jsx:146
msgid "Nested comments thread"
msgstr "Habiratutako iruzkinen haria"

#: src/pages/welcome.jsx:149
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr "Jarraitu elkarrizketak arazorik gabe. Erantzunak tolesten dira."

#: src/pages/welcome.jsx:157
msgid "Screenshot of grouped notifications"
msgstr "Taldekatutako jakinarazpenen pantaila-argazkia"

#: src/pages/welcome.jsx:161
msgid "Grouped notifications"
msgstr "Taldekatutako jakinarazpenak"

#: src/pages/welcome.jsx:164
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr "Antzeko jakinarazpenak taldekatzen eta tolesten dira anabasa gutxitzeko."

#: src/pages/welcome.jsx:173
msgid "Screenshot of multi-column UI"
msgstr "Zutabe anitzeko interfazearen pantaila-argazkia"

#: src/pages/welcome.jsx:177
msgid "Single or multi-column"
msgstr "Nahi beste zutabe"

#: src/pages/welcome.jsx:180
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr "Defektuz, zutabe bakarra ZEN antolaketa nahi dutenentzako. Zutabe gehiago konfiguratu daitezke erabilera aurreraturako."

#: src/pages/welcome.jsx:189
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr "Traola anitzeko denbora-lerroaren pantaila-argazkia, traola gehiago gehitzeko inprimakiarekin"

#: src/pages/welcome.jsx:193
msgid "Multi-hashtag timeline"
msgstr "Traola anitzeko denbora-lerroa"

#: src/pages/welcome.jsx:196
msgid "Up to 5 hashtags combined into a single timeline."
msgstr "Denbora-lerro bakarrean 5 traola ere batu daitezke."

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "Badirudi nabigatzailea laster-leihoak blokeatzen ari dela."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr "Zirriborro bat ikonotuta dago. Argitaratu edo zokoratu berri bat sortu baino lehen."

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr "Bidalketa bat irekita dago. Argitaratu edo zokoratu berri bat sortu baino lehen."

